{
    "Api tokens": {
        "add token": "Ajouter un jeton",
        "description": "Génère un jeton API pour le téléchargement de fichiers OEM pour TCT et Configurator ou un jeton API pour l'application à utiliser lors de la demande de services FOTA WEB. La documentation API est disponible <1>ici</1>.",
        "example": "Exemple : fota_token",
        "generate token": "Générer un jeton",
        "generated token": "Jeton généré",
        "last used at": "Dernière utilisation à",
        "name": "Nom du jeton",
        "never": "Jamais",
        "no tokens": "Aucun jeton disponible",
        "no tokens description": "Une fois les jetons ajoutés, ils seront répertoriés ci-dessous",
        "show token list": "Afficher la liste des jetons",
        "titles": {
            "Integration": {
                "description": "Utilisé pour l'intégration FOTA WEB dans votre système",
                "name": "Jeton d'intégration API"
            },
            "Tct": {
                "description": "Utilisé pour le téléchargement de fichiers OEM pour TCT et Configurator",
                "name": "Jeton TCT"
            }
        },
        "tokens": "Jetons API",
        "token type": "Type de jeton",
        "token was created": "Le jeton a été créé avec succès"
    },
    "Attributes": {
        "Completed": "Terminé",
        "Count": "Compter",
        "Current": "Actuel",
        "Date": "Date",
        "Empty": "Vide",
        "excluded files": "Fichiers exclus (samegrade)",
        "Failed": "Échec",
        "Feature": "Fonctionnalité",
        "file size bytes": "Taille totale des fichiers",
        "File_type": "Type de fichier",
        "File_version": "Version du fichier",
        "Fingerprint_id": "Identification par empreinte digitale",
        "Firmware_date": "Date du micrologiciel",
        "Firmware_version": "Révision",
        "included files": "Fichiers inclus",
        "Message": "Message",
        "Metadata": "",
        "newest": "Depuis le plus récent",
        "oldest": "Du plus ancien",
        "Order": "Commander",
        "Password_source": "",
        "Pending": "En attente",
        "Period": "Période",
        "Process_id": "",
        "Protocol_id": "Identifiant du protocole",
        "specific": "Spécifique",
        "Start": "Démarrer",
        "SystemGenerated": "",
        "txFwBundleFileTypes": {
            "fw_bundle_ble": "Micrologiciel BLE",
            "fw_bundle_ble_dtb": "BLE DTB",
            "fw_bundle_can": "Micrologiciel CAN",
            "fw_bundle_can_dtb": "CAN DTB",
            "fw_bundle_dtb": "TAPP DTB",
            "fw_bundle_mainfw": "Micrologiciel TAPP"
        },
        "UserEntered": "",
        "vehicle": "Véhicule",
        "Vehicle_id": "Identifiant du véhicule",
        "Vin": "VIN"
    },
    "Auth": {
        "account verification": {
            "check autheticator": "Vérifiez votre application d'authentification",
            "check email": "Vérifiez votre messagerie électronique",
            "code required": "Code de vérification requis.",
            "code sent to email": "Code envoyé à votre adresse e-mail",
            "code valid": "Le code est valable pendant plusieurs minutes.",
            "enter code below": "et entrez le code ci-dessous pour vous connecter.",
            "no access to otp": "",
            "recovery code": {
                "banner text": "",
                "description": "",
                "secondary text": "",
                "title": ""
            },
            "title": "",
            "use recovery code": ""
        },
        "account verification description": "Code de vérification requis. Vérifiez votre application d'authentification et saisissez le code ci-dessous pour vous connecter.",
        "check email": "Veuillez vérifier votre boîte de réception et cliquer sur le lien reçu pour réinitialiser votre mot de passe.",
        "community forum": "Forum d'assistance communautaire",
        "contact us": "Contactez-nous",
        "create initial password": "Créer un mot de passe",
        "create password": "Créez un mot de passe qui",
        "did not receive": "Vous n'avez pas reçu le lien ?",
        "do not have account": "Vous n'avez pas encore de compte ?",
        "email": "E-mail",
        "enter email": "Veuillez saisir votre adresse e-mail enregistrée ci-dessous pour recevoir les instructions de réinitialisation du mot de passe.",
        "forgot password": "Mot de passe oublié ?",
        "forgot your password": "Mot de passe oublié ?",
        "for ms365": "Pour les utilisateurs de Teltonika MS365",
        "invalid email format": "Format d'adresse e-mail non valide",
        "invalid password format": "Format de mot de passe non valide",
        "link sent": "Le lien a été envoyé !",
        "length": "8 caractères minimum",
        "lowercase": "Contient au moins 1 lettre minuscule",
        "new password": "Nouveau mot de passe",
        "password": "Mot de passe",
        "passwords do not match": "Les mots de passe ne correspondent pas",
        "privacy policy": "En utilisant FOTA WEB, vous acceptez notre <1>politique de confidentialité</1>.",
        "remember password": "Vous vous souvenez de votre mot de passe ?",
        "repeat password": "Répétez le mot de passe",
        "required": "Requis",
        "resend": "Renvoyer",
        "reset password": "Réinitialiser le mot de passe",
        "send reset link": "Envoyer le lien de réinitialisation",
        "sign in": "Se connecter",
        "sign in to fota": "Connectez-vous à votre compte FOTA WEB",
        "signup": "S'inscrire",
        "sso": "Se connecter avec Microsoft",
        "teltonika telematics": "Teltonika Telematics",
        "uppercase": "Lettre majuscule",
        "user consent text": "Je comprends et j'accepte les <1>Conditions d'utilisation</1> de Teltonika et le <2>Contrat de traitement des données</2>.",
        "welcome": "Bienvenue sur",
        "wiki": "Base de connaissances Wiki sur la télématique"
    },
    "Banner": {
        "activate banner": "",
        "apply link": "",
        "banner importance": "",
        "bold": "",
        "close link": "",
        "info": "",
        "italic": "",
        "link": "",
        "message": "",
        "text": "",
        "underline": "",
        "url": "",
        "warning": ""
    },
    "Button": {
        "accept": "Accepter",
        "accept all": "Tout accepter",
        "accept selected": "Accepter la sélection",
        "actions": "Actions",
        "add": "Ajouter",
        "add device": "Ajouter un appareil",
        "add more files": "Ajouter plus de fichiers",
        "add new": "Ajouter nouveau",
        "agree": "J'accepte",
        "all companies": "Toutes les entreprises",
        "all of company": "Tout {{companyName}}",
        "all rows selected": {
            "devices": "Tous les {{count}} appareils sont sélectionnés",
            "tasks": "Toutes les {{count}} tâches en attente/en cours sont sélectionnées",
            "groups": "Tous les {{count}} groupes sont sélectionnés",
            "files": "Tous les {{count}} fichiers sont sélectionnés",
            "companies": "Toutes les {{count}} entreprises sont sélectionnées",
            "users": "Tous les {{count}} utilisateurs sont sélectionnés"
        },
        "approve": "Approuver",
        "assign": "Attribuer",
        "assigning": "Attribution",
        "auto sync": "",
        "back": "Retour",
        "back to sign in": "Retour à la connexion",
        "cancel": "Annuler",
        "cancelling": "Annulation",
        "cancel all tasks in group": "Annuler toutes les tâches du groupe",
        "cancel tasks": "Annuler les tâches",
        "cannot create desktop licenses": "Les licences ne peuvent pas être créées pour les entreprises internes.",
        "cannot create offline licenses": "Les licences hors ligne ne peuvent pas être créées pour les licences non restreintes.",
        "change": "Modifier",
        "clear all": "Tout effacer",
        "clear all filters": "Effacer tous les filtres",
        "close": "Fermer",
        "company settings": "Paramètres de l'entreprise",
        "confirm": "Confirmer",
        "continue": "Continuer",
        "copied": "Copié",
        "copy all": "",
        "copy to clipboard": "Copier dans le presse-papiers",
        "create": "Créer",
        "create role": "Créer un rôle",
        "create task": "Créer une tâche",
        "creating": "Création",
        "default view": "Affichage par défaut",
        "delete": "Supprimer",
        "deleting": "Suppression",
        "deselect all": "Tout désélectionner",
        "device": "Appareil",
        "disable": "Désactiver",
        "disagree": "Je ne suis pas d'accord",
        "discard": "Rejeter",
        "download": "",
        "edit": "Modifier",
        "enable": "Activer",
        "export": "Exporter",
        "exporting": "Exportation",
        "filters": "Filtres",
        "finish": "",
        "find tool": "Trouver un outil",
        "first page": "Première page",
        "fmx and legacy": "FMx et Legacy",
        "ft platform": "Plateforme FT",
        "generate": "Générer",
        "generate codes": "",
        "go back": "Retour",
        "import": "Importer",
        "importing": "Importation",
        "invite": "Inviter",
        "invite user": "Inviter un utilisateur",
        "invite user to internal disabled": "Seuls les administrateurs et les utilisateurs disposant d'un niveau d'accès supérieur peuvent inviter des utilisateurs à rejoindre des entreprises internes.",
        "language": "Langue",
        "last page": "Dernière page",
        "logout": "Se déconnecter",
        "maximize details": "Maximiser les détails",
        "merge": "Fusionner",
        "merging": "Fusion",
        "minimize details": "Minimiser les détails",
        "more actions": "Plus d'actions",
        "more filters": "Plus de filtres",
        "more options": "Plus d'options",
        "move": "Déplacer",
        "moving": "Déplacement",
        "next": "Suivant",
        "next month": "Prochain mois",
        "next page": "Page suivante",
        "no actions available": "Aucune action disponible",
        "no permission": "Vous avez besoin de l'autorisation « {{permissionName}} ».",
        "no permissions": "Vous devez disposer des autorisations suivantes : {{permissionNames}}.",
        "notify when done": "M'avertir lorsque terminé",
        "number of selected companies": "{{companyCount}} de {{companyName}}",
        "only essential": "Uniquement l'essentiel",
        "open fota web": "Open FOTA WEB",
        "pages of": "sur {{total}}",
        "previous month": "Mois précédent",
        "previous page": "Page précédente",
        "print": "",
        "receive devices": "Recevoir des appareils",
        "refresh page": "Actualiser",
        "reject all": "Tout rejeter",
        "reset to default": "Réinitialisation aux paramètres par défaut",
        "retry failed tasks": "Réessayer les tâches ayant échoué",
        "retrying": "Réessayer",
        "return home": "Rentrons à la maison",
        "revert manual level change": "Revenir au changement de niveau manuel",
        "rows count per page": "Nombre de lignes par page",
        "rows selected": "{{count}} Sélectionné",
        "save": "Enregistrer",
        "saving": "",
        "see all": "Tout afficher",
        "select all": {
            "devices": "Sélectionner tous les {{count}} appareils",
            "tasks": "Sélectionner toutes les {{count}} tâches en attente/en cours d'exécution",
            "groups": "Sélectionner tous les {{count}} groupes",
            "files": "Sélectionner tous les {{count}} fichiers",
            "companies": "Sélectionner toutes les {{count}} entreprises",
            "users": "Sélectionner tous les {{count}} utilisateurs"
        },
        "select columns to show": "Sélectionnez les colonnes à afficher",
        "selected page is first": "La page sélectionnée est la première",
        "selected page is last": "La page sélectionnée est la dernière",
        "select rows": "Sélectionner les lignes",
        "send code": "Envoyer le code",
        "settings": "Paramètres",
        "show me": "Montrez-moi",
        "show more": "Afficher plus",
        "synchronize": "Synchroniser",
        "table statistics": "Statistiques du tableau",
        "table view": "Affichage sous forme de tableau",
        "transfer": "Transfert",
        "transferring": "Transfert",
        "transfer my devices": "Transférer mes appareils",
        "undo": "Annuler",
        "upload": "Téléchargement",
        "upload file": "Télécharger un nouveau fichier",
        "user": "Utilisateur",
        "verify": "Vérifier",
        "yes": "Oui"
    },
    "Cookies": {
        "always active": "Toujours actif",
        "analytics cookies": "Cookies analytiques",
        "analytics cookies description": "Ces traceurs sont utilisés à des fins d'analyse afin de collecter des données qui nous permettent de comprendre comment les utilisateurs interagissent avec nos sites Web. Ces informations nous permettent à la fois d'améliorer le contenu et de développer de meilleures fonctionnalités qui améliorent l'expérience utilisateur. Cette catégorie de cookies peut être désactivée.",
        "cookie banner message": "Nous et certains tiers utilisons des cookies ou des technologies similaires à des fins techniques et, avec votre consentement, à d'autres fins spécifiées dans la ",
        "cookie modal title": "Nous utilisons des cookies",
        "cookie policy": "Politique en matière de cookies",
        "essential cookies": "Cookies essentiels",
        "essential cookies description": "Ces traceurs sont utilisés pour des activités strictement nécessaires au fonctionnement ou à la fourniture du service que vous nous avez demandé. Ces cookies ne collectent pas d'informations vous concernant qui pourraient être utilisées à des fins marketing et ne mémorisent pas les sites que vous avez consultés sur Internet. Cette catégorie de cookies ne peut pas être désactivée."
    },
    "Dashboard": {
        "company level": {
            "description": {
                "Basic": "L'essentiel pour la mise à jour à distance des appareils",
                "Standard": "Automatisation et intégration avancées",
                "Premium": "Évolutivité pour les entreprises et accès anticipé aux mises à jour"
            },
            "resource limit types": {
                "Companies": "Entreprises",
                "Users": "Utilisateurs",
                "ConfigurationFiles": "Fichiers de configuration"
            }
        },
        "empty state": {
            "description": {
                "configurations": "Dès que les configurations sont détectées par FOTA WEB, vous pouvez voir la liste ici.",
                "firmware versions": "Dès que les versions du micrologiciel sont détectées par FOTA WEB, vous pouvez consulter la liste ici."
            },
            "title": {
                "configurations": "Aucune configuration détectée",
                "firmware versions": "Aucune version de micrologiciel détectée",
                "news": "Aucune actualité à afficher"
            }
        },
        "imported activated devices": {
            "days": {
                "1": "Aujourd'hui",
                "7": "7 jours",
                "30": "30 jours",
                "90": "90 jours"
            },
            "period": "Période"
        },
        "new": "",
        "news": {
            "body": {
                "1": "Nous vous rappelons que pour les utilisateurs invités après le 7 janvier 2025, la double authentification (2FA) sera obligatoire dès l'activation du compte. La double authentification est disponible via la vérification par e-mail ou une application d'authentification.",
                "2": "Nous tenons à vous informer de la maintenance prévue de FOTA WEB qui aura lieu le 3 juin 2025 à partir de 05h00 UTC. Veuillez noter que pendant la maintenance, tous les services seront indisponibles, y compris l'interface utilisateur, l'accès à l'API, l'exécution des tâches, les services OBD et CAN. La durée estimée de l'indisponibilité du service est d'une heure.",
                "3": "<section><p>Nous sommes ravis d'annoncer une amélioration importante de la fonctionnalité Device Unlocker sur FOTA WEB :</p></section> <section><p>Tous les rôles utilisateur peuvent désormais déverrouiller directement les appareils, sans avoir à contacter le support technique via le service d'assistance !</p> <p>Détails importants :</p> <ul><li>Les utilisateurs peuvent déverrouiller le même appareil jusqu'à 3 fois par période de 24 heures.</li> <li>Une fois la limite atteinte, l'option de déverrouillage sera temporairement désactivée pendant 24 heures. </li> <li>Si la limite de déverrouillage est dépassée, un message d'erreur s'affichera. Cette mise à jour réduit considérablement les temps d'attente et vous donne plus de contrôle sur la gestion de votre flotte. </li></ul></section> <section><a>Découvrez comment utiliser cette fonctionnalité</a></section>",
                "4": "<section><p>Nous sommes ravis d'annoncer de nouvelles mises à jour importantes du tableau de bord FOTA WEB ! Nous avons travaillé à l'amélioration de votre expérience grâce à des widgets améliorés et de nouvelles informations. </p></section> <section><h3>Nouvelles statistiques sur les appareils</h3> <p>Obtenez de meilleures informations sur l'activité de vos appareils grâce à deux nouveaux widgets :</p> <p><strong>Appareils activés</strong> : Cette nouvelle statistique vous indique le nombre d'appareils qui ont été activés (connectés) au cours de différentes périodes : aujourd'hui, 7 jours, 30 jours ou 90 jours. </p> <p><strong>Appareils importés</strong> : de la même manière, la nouvelle statistique « Appareils importés » permet de suivre le nombre d'appareils qui ont été importés au cours de la journée, des 7 derniers jours, des 30 derniers jours ou des 90 derniers jours.</p> </section> <section><h3>Présentation du widget Tâches</h3> <p>Suivez vos opérations grâce au tout nouveau widget Tâches :</p> <p><strong>Tâches en attente</strong> : consultez le nombre exact de vos tâches actuellement en attente.</p> <p><strong>Aperçu des tâches</strong> : obtenez une ventilation de la répartition de vos tâches par période (7 jours, 30 jours ou 90 jours) et par statut. Cela inclut les tâches terminées, terminées avec des erreurs ou échouées.</p></section> <section><h3>Aperçus plus intelligents du micrologiciel et de la configuration</h3> <p>Nous avons amélioré les widgets Versions du micrologiciel et Configurations :</p> <ul><li>Nous avons supprimé les statistiques « Inconnues » pour obtenir des données plus claires.</li> <li>Vous verrez initialement les 5 versions ou configurations les plus courantes, avec une option « Afficher plus » pour voir jusqu'à 100 entrées différentes. </li> <li>En survolant et en cliquant sur un micrologiciel ou une configuration spécifique, vous accéderez à la « page Appareils » et appliquerez un filtre.</li></ul></section> <section><h3>Widget Actualités amélioré</h3> <p>Restez informé en un clin d'œil ! Le widget Actualités a fait peau neuve et vous pouvez désormais cliquer sur n'importe quelle actualité pour lire l'intégralité de l'information. </p></section> <section><h3>État des appareils amélioré</h3> <p>Le widget État des appareils a été mis à jour visuellement pour plus de clarté. De plus, vous pouvez désormais passer la souris sur l'état d'un appareil et cliquer dessus pour filtrer les appareils ayant le même état sur la page « Appareils ».</p></section> <section><p>Nous espérons que ces mises à jour faciliteront encore davantage vos tâches quotidiennes et vous fourniront des informations plus utiles. Faites-nous part de votre avis !</p></section>",
                "5": "<section><h3>Modifications prévues de l'API</h3></section> <section><p>Le <strong>24 septembre 2025</strong>, nous supprimerons le champ « rôle » des réponses qui renvoient l'entité utilisateur (par exemple, les points de terminaison GET /users ou GET /users/{userId}). Cette modification vise à ouvrir la voie à un système d'autorisations plus robuste et plus flexible dans FOTA WEB.</p></section> <section><h3>Aperçu : rôles et autorisations</h3></section> <section><p> Nous reconnaissons que le système de rôles actuel n'offre pas la flexibilité dont vous avez besoin. Notre équipe de développement travaille d'arrache-pied sur une nouvelle fonctionnalité de <strong>gestion des rôles et des autorisations</strong> qui vous permettra de créer des rôles avec un contrôle granulaire des autorisations.</p></section> <section><p>Ce nouveau système vous permettra d'attribuer des rôles statiques aux utilisateurs ou d'adapter les autorisations à vos besoins spécifiques, et de créer des rôles personnalisés. Nous sommes très enthousiastes à ce sujet et nous sommes impatients de vous donner plus de détails sur la gestion des rôles et des autorisations lorsqu'elle sera disponible.</p></section>",
                "6": "<section><p>Nous sommes heureux d'annoncer la sortie de la nouvelle fonctionnalité <strong>« Rôles et autorisations »</strong>, conçue pour vous permettre de contrôler précisément l'accès des utilisateurs au sein de FOTA WEB. Cette fonctionnalité vous permet de définir les capacités des utilisateurs à l'aide de <strong>rôles</strong>, qui sont des ensembles d'<strong>autorisations</strong> spécifiques (par exemple, « Créer une tâche », « Inviter un utilisateur »). La fonctionnalité comprend des <strong>rôles statiques</strong> immuables (administrateur, utilisateur et invité) pour la sécurité de base, ainsi que des <strong>rôles personnalisés</strong> que seuls les utilisateurs <strong>Premium au niveau de l'entreprise</strong> peuvent créer ou modifier. Les autorisations sont désormais classées par domaines clés tels que les appareils, les tâches et les utilisateurs, et peuvent être consultées en survolant le « nombre d'autorisations » dans la section gestion. <strong>Tous les utilisateurs existants créés avant cette mise à jour se sont vu attribuer automatiquement le rôle « Administrateur », ce qui leur permet de conserver l'ensemble des actions qu'ils pouvaient effectuer auparavant. </strong></p></section> <section><p>Cette mise à jour garantit une meilleure sécurité et une meilleure répartition de la charge de travail. Les rôles sont désormais spécifiques à chaque entreprise et ne peuvent pas être hérités entre les structures d'entreprise. Notez qu'un rôle doit toujours être attribué lors de l'invitation ou du transfert d'un utilisateur vers une entreprise, et que les rôles avec des attributions d'utilisateurs actives ne peuvent pas être supprimés. Vous pouvez désormais utiliser le <strong>nouveau filtre « Rôle »</strong> sur la page <strong>Utilisateurs</strong> pour faciliter la gestion. Explorez dès aujourd'hui la section « Rôles et autorisations » pour configurer un accès adapté aux besoins de votre organisation.</p></section> <section><p>Pour obtenir un guide détaillé sur la gestion des utilisateurs et des rôles, veuillez consulter <a>la page wiki</a>.</p></section>",
                "7": "<section><p>Nous sommes ravis de vous présenter une nouvelle fonctionnalité puissante pour gérer vos tâches : <strong>Planifier par date</strong>, qui vous offre une plus grande précision pour les tâches urgentes !</p></section> <section><h3>Points forts</h3></section> <section><ul><li><strong>Délais spécifiques</strong> - Vous pouvez désormais planifier des tâches pour une <strong>date ou un intervalle de dates spécifiques</strong> à l'aide de la nouvelle option « Planifier par date ».</li> <li><strong>Comportement par défaut inchangé</strong> - La fonctionnalité familière <strong>Planifier par heure</strong> reste entièrement disponible. </li> <li><strong>Statut d'expiration</strong> - Les tâches non terminées à la date fixée passeront désormais automatiquement au statut <strong>Expiré</strong>, accompagné du message : <strong>« La tâche n'a pas été terminée pendant la période prévue. »</strong></li> <li><strong>Calendrier centré sur l'utilisateur</strong> - Tous les calendriers sont créés en fonction de <strong>votre heure locale</strong>.</li></ul></section> <section><h3>Comment ça marche</h3></section> <section><p>Lorsque vous définissez la tâche <strong>« Planifier par date »</strong> :</p> <ul><li>Vous sélectionnerez une <strong>« Date de début »</strong> et une <strong>« Date de fin »</strong> via le composant de sélection de date. </li> <li>Le sélecteur de date respecte la limite de temps d'expiration des tâches au niveau de l'entreprise.</li></ul></section><section><p>La fonctionnalité <strong>Planifier par date</strong> est actuellement réservée aux niveaux supérieurs de l'entreprise et n'est pas disponible pour le niveau <strong>Basique</strong>.</p></section>",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            },
            "title": {
                "1": "Authentification à deux facteurs obligatoire pour les nouveaux utilisateurs à compter du 7 janvier 2025",
                "2": "Maintenance planifiée le 3 juin 2025",
                "3": "Nouvelle fonctionnalité : déverrouillage plus facile des appareils pour tous les utilisateurs",
                "4": "Découvrez les nouveautés sur votre tableau de bord !",
                "5": "Important : modifications à venir de l'API et aperçu des rôles et autorisations",
                "6": "Nouvelle fonctionnalité disponible dès maintenant : contrôle amélioré grâce aux « rôles et autorisations »",
                "7": "Nouvelle fonctionnalité : plus de flexibilité avec la planification des tâches par date",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            }
        },
        "published": "Publié le",
        "take me there": "M'y rendre",
        "tasks": {
            "current": "Actuel",
            "status": {
                "completed": "Terminé",
                "completed_with_errors": "Terminé avec des erreurs",
                "failed": "Échec",
                "no tasks": "Aucune tâche"
            },
            "task_type_counts_7_days": {
                "progressBarTitle": "7 jours",
                "tooltipTitle": "7 derniers jours"
            },
            "task_type_counts_30_days": {
                "progressBarTitle": "30 jours",
                "tooltipTitle": "30 derniers jours"
            },
            "task_type_counts_90_days": {
                "progressBarTitle": "90 jours",
                "tooltipTitle": "90 derniers jours"
            }
        },
        "title": {
            "activated": "Appareils activés",
            "configurations": "Configurations",
            "device status": "État des appareils",
            "firmware versions": "Versions du micrologiciel",
            "imported": "Appareils importés",
            "news": "Actualités",
            "queued tasks": "Tâches en attente",
            "refreshed every hour": "Actualisé toutes les heures",
            "resource limits": "Limites des ressources",
            "task overview": "Aperçu des tâches",
            "tasks": "Tâches"
        },
        "tooltips": {
            "activated": "Nombre d'appareils connectés à FOTA WEB pour la première fois au cours de la période sélectionnée (aujourd'hui, les 7 derniers jours, les 30 derniers jours, les 90 derniers jours).",
            "configurations": "Affiche la répartition des noms de fichiers de configuration qui ont été téléchargés sur vos appareils. Jusqu'à 100 noms de fichiers uniques sont affichés.",
            "firmware versions": "Affiche la répartition des versions de micrologiciel signalées par vos appareils connectés. Jusqu'à 100 versions uniques sont affichées.",
            "imported": "Nombre d'appareils ajoutés à votre compte pendant la période sélectionnée (aujourd'hui, les 7 derniers jours, les 30 derniers jours, les 90 derniers jours)."
        }
    },
    "Date picker": {
        "disableFuture": "Date non valide",
        "disablePast": "Date non valide",
        "invalidDate": "Date non valide",
        "maxDate": "Date erronée",
        "minDate": "Date erronée",
        "shouldDisableDate": "Date non valide",
        "shouldDisableMonth": "Date non valide",
        "shouldDisableYear": "Date non valide"
    },
    "Device export": {
        "properties": {
            "activity_status": "",
            "bootloader": "",
            "company_name": "",
            "created_at": "",
            "current_configuration": "",
            "current_firmware": "",
            "description": "",
            "group_name": "",
            "gsm_number": "",
            "iccid": "",
            "imei": "",
            "imsi": "",
            "model": "",
            "model_platform": "",
            "modem_version": "",
            "oem_file_vehicle_name": "",
            "product_code": "",
            "seen_at": "",
            "serial": "",
            "task_queue": "",
            "updated_at": "",
            "vin": ""
        },
        "select data": ""
    },
    "Dialog": {
        "access group inheritance": "",
        "add new device": "Ajouter un nouvel appareil",
        "add new device description": "Ajoutez un ou plusieurs nouveaux appareils à l'entreprise et au groupe sélectionnés. Seuls les appareils hérités, tels que FM ou FMA, doivent être importés en cochant la case « Importer en tant qu'appareils hérités ».",
        "add new device legacy title": "Importation en tant qu'appareils hérités.",
        "add new device legacy description": "Définissez « Créé le » sur 2016.01.01 et « Modèle » sur Legacy.",
        "add new product code": "Ajouter un nouveau code produit",
        "add new product code description": "Ajoutez un nouveau code produit d'appareil et associez-le au forfait CAN disponible.",
        "all permissions": "Toutes les autorisations",
        "assign access group": "",
        "assign can package description": "Choisissez un type de forfait et attribuez-le à tous les appareils sélectionnés.",
        "assign role": "Attribuer un rôle",
        "attribute value": "Valeur d'attribut",
        "auto sync": "",
        "auto sync toggle": {
            "compatibility": {
                "compatible devices": "",
                "selected devices": ""
            },
            "descriptions": {
                "dialog": "",
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "modes": {
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "tooltips": {
                "bluetooth_auth_list_sync": "",
                "disabled submit": "",
                "main_configuration_sync": "",
                "manual_geofence_list_sync": "",
                "one_wire_auth_list_sync": ""
            }
        },
        "begin download": "Commencer le téléchargement",
        "by date": "Par date",
        "by time": "Par heure",
        "can adapter": "Adaptateur CAN",
        "cancel pending tasks": "Annuler les tâches en attente du même type",
        "cancel tasks": "Annuler les tâches",
        "cancel tasks in group": {
            "alert title": "Cette action peut prendre plusieurs minutes.",
            "banner description": "Pour voir l'état actualisé des tâches, veuillez vous reporter aux détails du groupe de tâches ou actualiser la page.",
            "banner title": "Cette action peut prendre plusieurs minutes, selon le nombre de tâches à effectuer.",
            "description": "En cliquant sur « Accepter », vous annulerez toutes les tâches en attente et en cours d'exécution. Êtes-vous sûr de vouloir continuer ?",
            "title": "Annuler toutes les tâches du groupe ?"
        },
        "canObd": "CAN/OBD",
        "carrier": "Carrier",
        "clear device history banner": "",
        "client email": "E-mail du représentant du client",
        "companies": "Entreprises",
        "company": "Entreprise",
        "company level": {
            "Basic": "Basique",
            "Internal": "Interne",
            "Premium": "Premium",
            "Standard": "Standard"
        },
        "company level change description": "Pour passer à un niveau supérieur, sélectionnez le nouveau niveau et expliquez pourquoi. Il n'est pas possible de passer à un niveau inférieur. Toutes les dates sont indiquées en UTC.",
        "company level manual revert": {
            "confirmation": {
                "description": "Cette action rétablira le niveau de l'entreprise au niveau attribué automatiquement « {{companyLevel}} ». Êtes-vous sûr de vouloir continuer ?",
                "title": "Revenir au changement de niveau manuel ?"
            },
            "description": "La réinitialisation ramènera le niveau de l'entreprise à son niveau attribué automatiquement.",
            "title": "Ce niveau d'entreprise a été mis à niveau manuellement jusqu'au {{expirationDate}}."
        },
        "company level type": "Type au niveau de l'entreprise",
        "company name": "Nom de l'entreprise",
        "company statistics": {
            "child companies": "Nombre de filiales",
            "devices": "Nombre d'appareils",
            "files": "Nombre de fichiers",
            "groups": "Nombre de groupes d'appareils",
            "tasks": "Nombre de tâches",
            "users": "Nombre d'utilisateurs"
        },
        "company type": {
            "All": "",
            "Client": "Client",
            "Internal": "Interne",
            "Virtual": "Virtuel"
        },
        "configuration": "Configuration",
        "confirmations": {
            "are you sure": "Êtes-vous sûr ?",
            "are you sure you wish to continue": "Êtes-vous sûr de vouloir continuer ?",
            "assign can package confirmation": "Êtes-vous sûr de vouloir attribuer le forfait sélectionné au nombre d'appareils spécifié ?",
            "cancel task confirmation": {
                "first part": "Êtes-vous sûr de vouloir annuler le nombre de tâches spécifié ?",
                "second part": "Si tel est le cas, entrez le nombre de tâches concernées et cliquez sur « Confirmer »."
            },
            "create task confirmation": "Êtes-vous sûr de vouloir créer une tâche pour le nombre d'appareils spécifié ?",
            "delete resource confirmation": {
                "first part": "Êtes-vous sûr de vouloir supprimer le nombre spécifié de {{resource}} ?",
                "second part": "Si tel est le cas, entrez le nombre de {{resource}} concernés et cliquez sur « Supprimer »."
            },
            "delete resources": {
                "companies": "entreprises",
                "files": "fichiers",
                "groups": "groupes d'appareils",
                "deviceModels": "modèles",
                "productCodes": "codes produit",
                "roles": "rôles",
                "users": "utilisateurs"
            },
            "description second part": "Si tel est le cas, entrez le nombre d'appareils concernés et cliquez sur « Confirmer ».",
            "export device data confirmation": "Êtes-vous sûr de vouloir exporter les données des appareils pour le nombre d'appareils spécifié ?",
            "file": "Entrez le nombre de lignes présentes dans le fichier",
            "filter": {
                "companies": "Entrez le nombre d'entreprises filtrées",
                "devices": "Entrez le nombre d'appareils filtrés",
                "files": "Entrez le nombre de fichiers filtrés",
                "groups": "Entrez le nombre de groupes d'appareils filtrés",
                "productCodes": "Entrez le nombre de codes produit filtrés",
                "tasks": "Entrez le nombre de tâches filtrées",
                "users": "Entrez le nombre d'utilisateurs filtrés"
            },
            "id_list": {
                "companies": "Entrez le nombre d'entreprises sélectionnées",
                "devices": "Entrez le nombre d'appareils sélectionnés",
                "files": "Entrez le nombre de fichiers sélectionnés",
                "groups": "Entrez le nombre de groupes d'appareils sélectionnés",
                "productCodes": "Entrez le nombre de codes produit sélectionnés",
                "tasks": "Entrez le nombre de tâches sélectionnées",
                "users": "Entrez le nombre d'utilisateurs sélectionnés"
            },
            "merge companies confirmation": "Vous êtes sur le point de fusionner les sociétés {{sourceCompany}} et {{targetCompany}}.",
            "move companies confirmation": "Vous êtes sur le point de transférer {{sourceCompany}} vers la société {{targetCompany}}.",
            "move devices confirmation": "Êtes-vous sûr de vouloir transférer le nombre d'appareils spécifié vers une autre entreprise ?",
            "number of lines": "Nombre de lignes",
            "selected 20 or more devices": "Vous avez sélectionné 20 appareils ou plus...",
            "transfer devices confirmation": "Êtes-vous sûr de vouloir transférer le nombre d'appareils spécifié vers une autre entreprise ?"
        },
        "confirm cannot revert": "Cette action est irréversible.",
        "confirm merge companies": "Êtes-vous sûr de vouloir fusionner ces entreprises ?",
        "count": "Compter",
        "create company": "Créer une entreprise",
        "create company description": "Créer une nouvelle société sous la société mère sélectionnée.",
        "create desktop license": "Créer une licence pour ordinateur de bureau",
        "create desktop license description": "Émettre une nouvelle licence FOTA Desktop pour l'entreprise cliente avec son adresse IP, sa clé matérielle et sa date d'expiration (2 ans maximum).",
        "create group": "Créer un groupe",
        "create group description": "Organisez les appareils en groupes pour simplifier la gestion et l'attribution groupée.",
        "create model": "Créer un modèle",
        "create model description": "Créez un nouveau modèle d'appareil en spécifiant le nom, la plateforme et la prise en charge TCT web.",
        "create offline license": "Créer une licence hors ligne",
        "create or edit group description": "Le micrologiciel et la configuration peuvent être attribués au groupe. Une fois cette opération effectuée, des tâches de mise à jour du micrologiciel et/ou de la configuration seront générées pour tous les membres du groupe (appareils).",
        "create role": "Créer un rôle",
        "create role description": "Créez un nouveau rôle en lui attribuant un nom et une description, en sélectionnant une entreprise et en lui attribuant des autorisations spécifiques.",
        "create smart group": "Créer un groupe intelligent",
        "create smart group banner message": "",
        "create smart group description": "Les fichiers de configuration et de micrologiciel peuvent être attribués au groupe pour chaque plateforme. Une fois les fichiers attribués, des tâches de mise à jour seront générées pour tous les appareils du groupe.",
        "create task description first step": "Créez une grande variété de tâches, allant de la mise à jour de la configuration ou du micrologiciel à la réception de journaux, de configurations et plus encore à partir d'appareils sélectionnés ou filtrés. De plus, vous pouvez planifier les tâches créées à votre convenance.",
        "create task description last step": "Assurez-vous que les informations ci-dessous sont correctes avant de créer la tâche.",
        "current level": "niveau actuel",
        "custom resource limits": {
            "at least one limit must be higher": "Au moins une limite doit être supérieure à la valeur par défaut du niveau Premium.",
            "configuration files per device": "Fichiers de configuration par appareil",
            "confirmation modal description": "Êtes-vous sûr de vouloir modifier les limites de ressources suivantes de la société « {{companyName}} » ?",
            "confirmation modal title": "Modifier les limites des ressources de l'entreprise ?",
            "count": {
                "companies count": "Nombre d'entreprises : {{number}}",
                "configuration files per device count": "Nombre de fichiers de configuration par appareil : {{number}}",
                "tasks per group count": "Nombre de tâches par groupe : {{number}}",
                "users count": "Nombre d'utilisateurs : {{number}}"
            },
            "explanations": {
                "companies": "Nombre total de filiales pouvant être créées dans la hiérarchie de l'entreprise.",
                "configuration files per device": "Nombre de fichiers de configuration pouvant être stockés : 1 appareil équivaut à 1 fichier de configuration. Le nombre minimum garanti de fichiers de configuration est de 100 pour chaque niveau d'entreprise.",
                "tasks per group": "Nombre de tâches pouvant être regroupées dans un même groupe de tâches.",
                "users": "Nombre total d'utilisateurs pouvant être créés dans la hiérarchie de l'entreprise."
            },
            "main modal description": "Définissez une quantité personnalisée de ressources pour différents types de ressources tels que les entreprises, les utilisateurs, les tâches par groupe de tâches ou les fichiers de configuration. Les ressources personnalisées resteront actives jusqu'à l'expiration du niveau Premium ou jusqu'à leur réinitialisation manuelle.",
            "resources limit type": "Type de limite des ressources",
            "revert custom resource limits": "Rétablir les limites de ressources personnalisées",
            "revert custom resource limits description": "La réinitialisation de toutes les limites rétablit les valeurs par défaut des ressources et fait passer le niveau de l'entreprise à Premium.",
            "revert custom resource limits description confirmation": "Cette action rétablira les limites de ressources attribuées automatiquement pour le niveau « Premium ». Êtes-vous sûr de vouloir continuer ?",
            "revert custom resource limits title": "Les limites de ressources de cette entreprise ont été définies manuellement.",
            "revert custom resource limits title confirmation": "Rétablir les limites de ressources personnalisées ?",
            "tasks per group": "Tâches par groupe"
        },
        "date range": "Période",
        "date to": "à",
        "delete companies": "Supprimer des entreprises",
        "delete deviceModels": "Supprimer les modèles",
        "delete files": "Supprimer des fichiers",
        "delete file warning": "La suppression de fichiers annulera les tâches et les groupes de tâches associés.",
        "delete groups": "Supprimer des groupes d'appareils",
        "delete productCodes": "Supprimer les codes produit",
        "delete roles": "Supprimer les rôles",
        "delete tasks and history": "",
        "delete users": "Supprimer des utilisateurs",
        "description": "Description",
        "desktop license delete description": "Êtes-vous sûr de vouloir supprimer la licence desktop « {{name}} » ?",
        "desktop license name": "Nom de la licence pour desktop",
        "device identifier": "Identifiant de l'appareil",
        "device transfer": {
            "main": {
                "description": "Transférez les appareils sélectionnés ou filtrés vers une entreprise non liée à l'aide d'un jeton généré par l'entreprise destinataire.",
                "title": "Transfert d'appareils"
            },
            "receive devices": {
                "copy token": "Copiez et envoyez le jeton généré à la personne chargée de transférer les appareils de son entreprise vers la vôtre.",
                "description": "Créez un jeton pour les appareils récepteurs et envoyez-le à la société de destination.",
                "token info": "Le jeton est à usage unique et expire après 21 jours."
            },
            "transfer devices": {
                "confirmation": "Êtes-vous sûr de vouloir transférer les appareils à l'entreprise ci-dessous ?",
                "device token": "Le jeton de transfert de l'appareil doit être obtenu auprès du responsable de l'entreprise à laquelle vous souhaitez transférer vos appareils.",
                "transfer from file": "Téléchargez un fichier contenant la liste des appareils (IMEI) que vous souhaitez transférer de votre entreprise vers l'entreprise dont vous venez d'entrer le jeton."
            }
        },
        "device transfer token": "Jeton de transfert d'appareil",
        "downgrading company level is not possible": "Il n'est pas possible de rétrograder un niveau d'entreprise",
        "download sample file message": "Téléchargez un <1>modèle CSV</1> pour voir un exemple du format requis.",
        "edit group banner message": "La modification du micrologiciel et/ou des fichiers de configuration annulera toutes les tâches en attente du même type.",
        "edit group description": "Modifiez les paramètres de ce groupe d'appareils.",
        "edit role description": "Personnalisez le nom, la description et les autorisations du rôle. L'entreprise attribuée ne peut pas être modifiée.",
        "edit smart group description": "Les fichiers de configuration et de micrologiciel peuvent être attribués ou modifiés pour le groupe pour chaque plateforme. Une fois les fichiers attribués ou modifiés, des tâches de mise à jour seront générées pour tous les appareils du groupe.",
        "email": "E-mail",
        "enter": "Entrer",
        "enter code": "Entrer le code",
        "enter description": "Entrer la description",
        "enter name": "Entrez le nom",
        "example": "Exemple :",
        "expires at": "Expire à",
        "explanation": "Explication",
        "export device data": "Exportation des données des appareils",
        "export device description": "",
        "export file format": "Format de fichier d'exportation",
        "feature": "Fonctionnalité",
        "feature control": "Contrôle des fonctionnalités",
        "field disabled until company selected": "Ce champ est désactivé tant que la société n'est pas sélectionnée.",
        "firmware": "Micrologiciel",
        "files to download": "Fichiers à télécharger",
        "file upload": {
            "banner text": {
                "1_wire_authorization_list": "La liste d'autorisation 1-Wire téléchargée sera automatiquement triée afin d'améliorer la vitesse et la précision des fonctionnalités.",
                "bluetooth_authorization_list": "La liste d'autorisation Bluetooth téléchargée sera automatiquement triée afin d'améliorer la vitesse et la précision des fonctionnalités."
            },
            "endings": {
                "file": "fichier",
                "files": "fichiers"
            },
            "fail": {
                "multiple": "{{failCount}} sur {{totalCount}} {{fileEnding}} n'ont pas été téléchargés en raison d'une erreur.",
                "single": "{{failCount}} sur {{totalCount}} {{fileEnding}} n'ont pas été téléchargés en raison d'une erreur."
            },
            "success": {
                "multiple": "Tous les fichiers ont été ajoutés avec succès aux entreprises sélectionnées.",
                "single": "Tous les fichiers ont été ajoutés avec succès à l'entreprise sélectionnée."
            }
        },
        "filtered": "Filtré",
        "filtered companies": "Entreprises filtrées",
        "filtered devices": "Appareils filtrés",
        "filtered files": "Fichiers filtrés",
        "filtered groups": "Groupes filtrés",
        "filtered tasks": "Tâches filtrées",
        "filtered users": "Utilisateurs filtrés",
        "find tool": {
            "device": {
                "error not valid": "L'IMEI doit comporter 15 caractères",
                "error subtitle": "Appareil introuvable. Veuillez essayer de saisir un autre numéro IMEI.",
                "error title": "Aucun appareil trouvé",
                "link": "Accéder à l'appareil",
                "no permission": "Vous n'êtes pas autorisé à afficher cet appareil."
            },
            "user": {
                "error not valid": "Format d'adresse e-mail non valide",
                "error subtitle": "Utilisateur introuvable. Veuillez essayer avec une autre adresse e-mail.",
                "error title": "Aucun utilisateur trouvé",
                "link": "Accéder à l'utilisateur",
                "no permission": "Vous n'avez pas l'autorisation de consulter cet utilisateur."
            }
        },
        "firmware date": "Date du micrologiciel",
        "from form": "À partir du formulaire",
        "from file": "À partir du fichier",
        "general": "Généralités",
        "gsm_number": "Numéro GSM",
        "iccid": "ICCID",
        "imei": "IMEI",
        "imei restriction": "Restriction IMEI",
        "import device data": "Importer les données des appareils",
        "import device data description": "Importez les données d'attributs sélectionnées pour les appareils figurant dans la liste fournie.",
        "import device data info": "Chaque attribut a une limite maximale de caractères indiquée entre parenthèses. Si un attribut comporte plus de caractères que la limite maximale, il sera automatiquement raccourci jusqu'à la limite maximale.",
        "import device data limit": "(max {{limit}} caractères)",
        "imsi": "IMSI",
        "input text too long": "Le texte est trop long. Maximum {{maxLength}} caractères autorisés.",
        "invalid hardware key": "Format de clé matérielle non valide",
        "invalid imei": "L'IMEI n'est pas valide",
        "invalid ipv4": "Format IPv4 non valide",
        "invalid serial": "Numéro de série invalide",
        "invalid value": "Valeur non valide",
        "inverted selection": "Sélection inversée",
        "invite user": "Inviter un utilisateur",
        "invite user description": "Invitez un nouvel utilisateur à rejoindre la société mère sélectionnée et définissez son rôle. Après l'envoi, l'utilisateur disposera de 30 jours pour accepter l'invitation avant qu'elle n'expire.",
        "invite user max roles": "Cinq rôles maximum autorisés. Désélectionnez-en un pour continuer.",
        "log files": "Fichiers journaux",
        "make": "Créer",
        "manage permissions": "Gère toutes les données au niveau du compte et du site.",
        "maximum value is": "La valeur maximale est {{value}}",
        "merge companies": "Fusionner les entreprises",
        "merge companies info": "Toutes les ressources de l'entreprise source (appareils, groupes, fichiers, entreprises, utilisateurs et leurs rôles) seront transférées vers l'entreprise cible. Vous pouvez revoir les rôles des utilisateurs avant la fusion. L'entreprise source sera ensuite supprimée.",
        "merge companies disabled option": {
            "client to internal": "Les entreprises de type client ne peuvent pas être fusionnées avec des entreprises de type interne.",
            "internal": "Les entreprises de type interne ne peuvent pas être fusionnées.",
            "lz code": "Les entreprises avec Code ne peuvent pas être fusionnées."
        },
        "minimum value is": "La valeur minimale est {{value}}",
        "move companies disabled option": {
            "internal": "Les entreprises de type interne ne peuvent pas être déplacées."
        },
        "move device": "Déplacer l'appareil",
        "move device description": "Déplacez les appareils sélectionnés ou filtrés vers l'entreprise existante et/ou le groupe dans la hiérarchie de l'entreprise.",
        "move device group": "",
        "move device group banner": "",
        "move device group description": "",
        "move devices": "Déplacer des appareils",
        "name": "Nom",
        "newest": "Depuis le plus récent",
        "no dropdown files": {
            "description": "Pour sélectionner cette option, téléchargez un nouveau fichier $t(Dialog##no dropdown files##file names##{{fileName}}).",
            "description no permission create file": "",
            "file names": {
                "1_wire_authorization_list": "Liste d'autorisation 1-Wire",
                "adas_firmware": "Micrologiciel ADAS",
                "ble_fw": "Micrologiciel BLE",
                "blue_nrg": "Micrologiciel BlueNrg",
                "bluetooth_authorization_list": "Liste d'autorisation Bluetooth",
                "can_chip_firmware": "Micrologiciel FM CAN Chip",
                "carrier_advance_firmware": "Micrologiciel Carrier Advance",
                "carrier_advance_settings": "Paramètres avancés du Carrier Advance",
                "carrier_apx_firmware": "Micrologiciel Carrier APX",
                "carrier_apx_settings": "Paramètres Carrier APX",
                "certificate": "Certificat TLS",
                "configuration": "configuration",
                "dsm_firmware": "Micrologiciel DSM",
                "dtb": "DTB",
                "firmware": "micrologiciel",
                "fw_bundle": "Ensemble de micrologiciels",
                "gnssm_download_assistant": "Assistant de téléchargement GNSS-M",
                "gnssm_firmware": "Micrologiciel GNSS-M",
                "main configuration": "",
                "manual_geofence_list": "Liste manuelle des scénarios de géorepérage",
                "meig_modem_firmware": "Micrologiciel du modem MeiG",
                "netprisma_modem_firmware": "Micrologiciel du modem NETPRISMA",
                "psub": "Abonnement",
                "quectel_modem_firmware": "Micrologiciel du modem Quectel",
                "simcom_modem_firmware": ""
            },
            "main": "Il n'y a pas de fichiers $t(Dialog##no dropdown files##file names##{{fileName}})."
        },
        "none": "Aucun",
        "obd oem": "OBD OEM",
        "offline license delete description": "Êtes-vous sûr de vouloir supprimer la licence hors ligne « {{name}} » ?",
        "oldest": "Du plus ancien",
        "only integers": "Seuls les nombres entiers sont valides",
        "only numbers": "Seuls les chiffres sont valides",
        "optional": "facultatif",
        "other companies": "Autres entreprises",
        "parent company": "Société mère",
        "permission preset": "Autorisations prédéfinies",
        "platform compatibility": {
            "banner text": "Certains modèles d'appareils sélectionnés ne sont pas compatibles avec le type de tâche sélectionné. Ce type de tâche ne sera pas créé par défaut pour les modèles d'appareils incompatibles.",
            "compatible model devices": "Modèles d'appareils compatibles",
            "count text": "Une tâche sera créée pour <1>{{compatibleCount}}</1> des {{totalCount}} appareils.",
            "create tasks for incompatible devices": "Création de tâches pour les appareils incompatibles.",
            "devices from file": "Appareils à partir du fichier",
            "platform": "Plateforme {{title}}",
            "task applies": "La tâche s'applique à",
            "task cannot be created": "Il n'est pas possible de créer des tâches pour les modèles d'appareils incompatibles."
        },
        "receiving company": "Cette entreprise recevra vos appareils",
        "resend user invitation": "",
        "retry tasks in group": {
            "alert title": "Cette action peut prendre plusieurs minutes.",
            "banner description": "Pour voir l'état actualisé des tâches, veuillez vous reporter aux détails du groupe de tâches ou actualiser la page.",
            "description": "En appuyant sur « Accepter », toutes les tâches ayant échoué seront réessayées. Êtes-vous sûr de vouloir continuer ?",
            "title": "Réessayer toutes les tâches du groupe ?"
        },
        "revision": "Révision",
        "revision value error": "La valeur doit être à deux chiffres (00 - 99).",
        "role name": "Nom du rôle",
        "root company": "Société mère",
        "sales email": "E-mail du directeur commercial",
        "scheduled time warning": "Les tâches avec une heure programmée ne modifient pas la configuration de l'heure de connexion FOTA de l'appareil. Les tâches seront exécutées si l'appareil se connecte à FOTA pendant la plage horaire sélectionnée. Veuillez vous assurer que les appareils sont configurés pour se connecter à FOTA WEB pendant une période au moins égale à la plage horaire sélectionnée.",
        "schedule task": "Planification des tâches",
        "select": "Sélectionner",
        "select at least one": {
            "companies": "Veuillez sélectionner au moins une entreprise",
            "devices": "Veuillez sélectionner au moins un appareil",
            "files": "Veuillez sélectionner au moins un fichier",
            "groups": "Veuillez sélectionner au moins un groupe",
            "tasks": "Veuillez sélectionner au moins une tâche",
            "users": "Veuillez sélectionner au moins un utilisateur"
        },
        "selected": "Sélectionné",
        "selected companies": "Entreprises sélectionnées",
        "selected deviceModels": "Modèles sélectionnés",
        "selected devices": "Appareils sélectionnés",
        "selected files": "Fichiers sélectionnés",
        "selected groups": "Groupes d'appareils sélectionnés",
        "selected productCodes": "Codes produit sélectionnés",
        "selected roles": "Rôles sélectionnés",
        "selected tasks": "Tâches sélectionnées",
        "selected users": "Utilisateurs sélectionnés",
        "select company": "",
        "select group": "",
        "select time interval": "Sélectionnez l'intervalle de temps",
        "selected time window": "Période sélectionnée : {{fromDate}} à {{toDate}}",
        "set bluetooth password": {
            "bluetooth password": "",
            "repeat bluetooth password": "",
            "enter password": "",
            "password source": "",
            "rules": {
                "allowed characters": "",
                "characters length": "",
                "passwords must match": ""
            },
            "SystemGenerated": {
                "description": ""
            },
            "UserEntered": {
                "description": ""
            }
        },
        "show files for selected companies only": "",
        "smart group": {
            "description": "Sélectionnez les fichiers disponibles pour les appareils de la plateforme {{platformName}}.",
            "title": "Fichiers de la plateforme {{platformName}}"
        },
        "sn": "Numéro de série.",
        "specific": "Spécifique",
        "time period": "Période",
        "time period custom": "Personnalisé",
        "tls certificate transfer info": "",
        "token has expired": "Le jeton a expiré",
        "token is valid": "Le jeton est valide",
        "transfer companies": "Sociétés de transfert",
        "transfer companies description": "Choisissez si vous souhaitez fusionner ou séparer deux entreprises. Certaines options sont irréversibles.",
        "transfer devices": "Transférer des appareils",
        "tri source": {
            "selected tab description": {
                "create task": "La tâche choisie sera créée pour les appareils sélectionnés à l'aide de la case à cocher.",
                "general": "L'action choisie sera exécutée pour les appareils sélectionnés à l'aide de la case à cocher."
            },
            "filtered tab description": {
                "create task": "La tâche choisie sera créée pour les appareils filtrés à l'aide d'un ou plusieurs filtres disponibles.",
                "general": "L'action choisie sera exécutée pour les appareils filtrés à l'aide d'un ou plusieurs filtres disponibles."
            },
            "from file tab description": {
                "create task": "La tâche choisie sera créée pour les appareils spécifiés dans le fichier téléchargé.",
                "general": "L'action choisie sera exécutée pour les appareils spécifiés dans le fichier téléchargé."
            }
        },
        "unlocker": {
            "generate unlock key": "Générer une clé de déverrouillage",
            "generate unlock key description": "Saisissez le « code de verrouillage » de l'appareil fourni par TCT dans le champ ci-dessous. Appuyez sur le bouton « Générer » pour générer une clé de déverrouillage, puis utilisez-la dans TCT pour déverrouiller votre appareil.",
            "invalid lock code": "Code de verrouillage de l'appareil non valide.",
            "limit reached": "Vous avez atteint le nombre maximal de clés de déverrouillage générées.",
            "lock code": "Code de verrouillage",
            "select device platform": "Sélectionnez la plateforme de l'appareil",
            "select device platform description": "Sélectionnez la plateforme d'appareil appropriée. Les appareils télématiques sont classés en trois générations de plateformes : <1>FT</1> (FTx, ATx), <2>FMx</2> (divers modèles FM, FMT, TAT, MSP, TFT, TST, GH et TMT) et <3>Legacy</3> (anciens modèles FM, FMA et GH).",
            "unlock key": "Débloquer la clé",
            "unlock key success message": "Clé de déverrouillage générée avec succès."
        },
        "upload file": "Télécharger un fichier",
        "upload file description": "Téléchargez jusqu'à {{count}} fichiers à la fois à l'aide du champ glisser-déposer ou en les sélectionnant.",
        "upload firmware bundle container info": "",
        "upload firmware downgrade protection info": "Les versions 04.00.00 et supérieures du micrologiciel incluent une protection contre la rétrogradation. Pour plus de détails sur les modifications du micrologiciel, veuillez consulter notre documentation sur <1>Teltonika GPS Wiki</1>. En appuyant sur le bouton « Suivant », vous acceptez et comprenez les informations ci-dessus.",
        "upload firmware unsupported info": "La mise à jour vers cette version n'est pas disponible. Veuillez contacter le service d'assistance Teltonika ou votre responsable commercial Teltonika.",
        "use at least one filter": "Veuillez utiliser au moins un filtre",
        "user": "Utilisateur",
        "valid until": "Valable jusqu'au",
        "valid until date disable description": "Ce champ ne peut être modifié que lorsque la période est définie sur « Personnalisée »",
        "vehicle model": "Modèle"
    },
    "Dropzone": {
        "add file": "Ajouter un fichier",
        "add files": "Ajouter des fichiers",
        "drop file to upload": "Déposez le fichier à télécharger",
        "drop files to upload": "Déposez les fichiers à télécharger",
        "error uploading the file": "Une erreur s'est produite lors du téléchargement du fichier",
        "file invalid type": "Type de fichier invalide sélectionné.",
        "file successfully uploaded": "Fichier téléchargé avec succès",
        "file syntax": "La syntaxe des fichiers est la suivante :",
        "invalid format or size": "",
        "max file size": "",
        "maximum file limit reached": "La limite maximale de fichiers a été atteinte.",
        "only one file can be attached": "Un seul fichier peut être joint.",
        "or drop file to upload": "Ou déposez le fichier à télécharger",
        "or drop files to upload": "Ou déposez les fichiers à télécharger",
        "rows detected": "Lignes du fichier détectées avec succès",
        "select file": "Sélectionner un fichier",
        "select files": "Sélectionner les fichiers",
        "select file type": "Veuillez d'abord sélectionner le type de fichier.",
        "supported formats": "Formats pris en charge",
        "too long file name": "Le nom du fichier est trop long. Maximum {{maxLength}} caractères autorisés.",
        "too many files description": "Les autres fichiers peuvent être téléchargés après avoir téléchargé les fichiers sélectionnés.",
        "too many files title": "Le nombre maximal de fichiers que vous pouvez joindre à la fois est de {{maxFiles}}."
    },
    "Error": {
        "error": "Erreur",
        "message wait": "Patientez jusqu'à ce que nous corrigions l'erreur.",
        "title": "Une erreur s'est produite !"
    },
    "Feature highlight": {
        "got it": "Compris",
        "new feature": "Nouvelle fonctionnalité !",
        "scenarios description": "Vous pouvez désormais configurer l'un des scénarios suivants sur votre appareil : excès de vitesse, détection de collision ou détection de remorquage."
    },
    "Filter": {
        "access group": "",
        "activity_status": "Statut",
        "all permissions": "Toutes les autorisations",
        "batch_id": "ID de lot",
        "company_id": "Entreprise",
        "company selector": "",
        "configuration change origin": "",
        "configuration_file_id": "",
        "configuration type": "",
        "created_by": "Créé par",
        "current_configuration": "Configuration",
        "current_firmware": "Micrologiciel",
        "device_imei": "IMEI de l'appareil",
        "file type": "Type de fichier",
        "filtered by": "Filtré par",
        "filters used": "Filtres utilisés",
        "firmware_file_id": "",
        "ft_bluetooth_auth_list_file_id": "",
        "ft_configuration_file_id": "",
        "ft_firmware_file_id": "",
        "ft_one_wire_auth_list_file_id": "",
        "group_id": "Groupe",
        "id": "ID",
        "Invalid company": "Entreprise non valide",
        "model": "Modèle",
        "model_platform": "Plateforme",
        "Multiple companies": "Plusieurs entreprises",
        "parent company": "Société mère",
        "permission": "Autorisation",
        "permission status": "Statut",
        "role": "Rôle",
        "spec_id": "Spec ID",
        "status_id": "Statut",
        "supported_task_type": "Type de tâche",
        "table filters": "Filtres de tableau",
        "task type": "Type de tâche",
        "task_queue": "File d'attente",
        "type": "Type",
        "user status": "Statut"
    },
    "Flash": {
        "account was deleted": "",
        "ADAS firmware file size can't be zero": "La taille du fichier du micrologiciel ADAS ne peut pas être nulle.",
        "ADAS firmware is invalid.": "Le micrologiciel ADAS n'est pas valide.",
        "All notifications were deleted.": "Toutes les notifications ont été supprimées.",
        "All notifications were marked as read.": "Toutes les notifications ont été marquées comme lues.",
        "At least one user role must be provided.": "Au moins un rôle utilisateur doit être fourni.",
        "Attributes length is invalid": "La longueur des attributs n'est pas valide.",
        "Banner was updated.": "",
        "Batch was discarded": "Le lot a été rejeté.",
        "Bulk attribute update job was created. Devices' attributes will be updated shortly.": "Une tâche de mise à jour groupée des attributs a été créée. Les attributs des appareils seront mis à jour sous peu.",
        "Bulk create job was created. Devices will be created shortly.": "Une tâche de création groupée a été créée. Les appareils seront créés sous peu.",
        "Bulk create job was created. Tasks will be created shortly.": "Une tâche de création en masse a été créée. Les tâches seront créées sous peu.",
        "Bulk delete job was created. Companies will be removed shortly.": "Une tâche de suppression groupée a été créée. Les entreprises seront supprimées sous peu.",
        "Bulk delete job was created. Devices will be removed shortly.": "Une tâche de suppression groupée a été créée. Les appareils seront supprimés sous peu.",
        "Bulk delete job was created. Files will be removed shortly.": "Une tâche de suppression groupée a été créée. Les fichiers seront supprimés sous peu.",
        "Bulk delete job was created. Groups will be removed shortly.": "Une tâche de suppression groupée a été créée. Les groupes seront supprimés sous peu.",
        "Bulk delete job was created. Product codes will be removed shortly.": "Une tâche de suppression groupée a été créée. Les codes produit seront supprimés sous peu.",
        "Bulk delete job was created. Users will be removed shortly.": "Une tâche de suppression groupée a été créée. Les utilisateurs seront supprimés sous peu.",
        "Bulk task create job was created. Tasks will be created shortly.": "Une tâche groupée a été créée et les tâches apparaîtront sous peu. Les tâches se trouvent sur la page « Groupes de tâches », sous les détails du groupe de tâches.",
        "Bulk update job was created. Devices will be updated shortly.": "Une tâche de mise à jour groupée a été créée. Les appareils seront mis à jour sous peu.",
        "Bulk update job was created. Tasks will be updated shortly.": "Une tâche de mise à jour groupée a été créée. Les tâches seront mises à jour sous peu.",
        "Can adapter was added.": "Un adaptateur a été ajouté.",
        "Can adapter was deleted.": "L'adaptateur a été supprimé.",
        "Can adapter was updated.": "L'adaptateur a été mis à jour.",
        "Can chip firmware file size can't be zero": "La taille du fichier du micrologiciel de la puce ne peut pas être nulle.",
        "Can chip firmware is invalid.": "Le micrologiciel de la puce peut être invalide.",
        "Cannot delete company. Company is not empty.": "Impossible de supprimer l'entreprise. L'entreprise n'est pas vide.",
        "Cannot delete file. It is used by pending or running tasks.": "Impossible de supprimer le fichier. Il est utilisé pour les tâches en attente ou en cours d'exécution.",
        "Cannot delete file. It is used by running tasks.": "Impossible de supprimer le fichier. Il est utilisé par des tâches en cours d'exécution.",
        "Cannot delete file. There are tasks waiting for approval.": "",
        "Cannot delete product code assigned to devices.": "Impossible de supprimer le code produit attribué aux appareils.",
        "check your email for details": "",
        "Companies count limit exceeded.": "Limite du nombre d'entreprises dépassée.",
        "Companies in the request must belong to the selected root.": "Les entreprises concernées par la demande doivent appartenir à la racine sélectionnée.",
        "Company merge job was created. It will be merged shortly.": "Une tâche de fusion d'entreprises a été créée. La fusion aura lieu prochainement.",
        "Company name already exist.": "Le nom de la société existe déjà.",
        "Company level change is not allowed.": "Aucun changement au niveau de l'entreprise n'est autorisé.",
        "Company level successfully changed": "Modification réussie au niveau de l'entreprise.",
        "company level successfully reverted": "Le niveau de l'entreprise a été rétabli avec succès au niveau attribué automatiquement.",
        "Company not allowed to be merged": "La société n'est pas autorisée à fusionner.",
        "company resource limits changed": "Limites des ressources de l'entreprise modifiées avec succès.",
        "Company was created.": "La société a été créée.",
        "Company was deleted.": "La société a été supprimée.",
        "Company was updated.": "La société a été mise à jour.",
        "compatibilities added": "{{count}} nouvelle(s) compatibilité(s) ajoutée(s) lors de la synchronisation.",
        "compatibilities synchronized": "Synchronisation réussie des compatibilités manquantes.",
        "Configuration cannot have FOTA functionality disabled": "La fonctionnalité FOTA ne peut pas être désactivée dans la configuration.",
        "Configuration file cannot contain duplicate parameters": "Le fichier de configuration ne peut pas contenir de paramètres en double.",
        "Configuration file size can't be zero": "La taille du fichier de configuration ne peut pas être nulle.",
        "Configuration files count limit exceeded.": "Limite du nombre de fichiers de configuration dépassée.",
        "Configuration version must be defined": "La version de configuration doit être définie.",
        "custom resource limits successfully reverted": "Les limites de ressources personnalisées ont été rétablies avec succès aux limites attribuées automatiquement.",
        "Custom roles feature is not enabled.": "La fonctionnalité de rôles personnalisés ne peut être utilisée que par les utilisateurs disposant d'un compte Premium au niveau de l'entreprise. Les rôles personnalisés créés précédemment peuvent être supprimés.",
        "desktop license added": "La licence Desktop « {{name}} » a été ajoutée avec succès.",
        "Devices already are in target company": "Les appareils sont déjà présents dans l'entreprise cible.",
        "Device already exists.": "L'appareil existe déjà.",
        "Device bulk attribute update file cannot be empty": "Le fichier de mise à jour groupée des attributs des appareils ne peut pas être vide.",
        "Device bulk attribute update file should be .csv": "Le fichier de mise à jour groupée des attributs des appareils doit être au format .csv.",
        "Device export limit reached. You can not export more than 100000 devices": "Limite d'exportation des appareils atteinte. Vous ne pouvez pas exporter plus de 100 000 appareils.",
        "Device import limit reached. You can not import more than 100 devices": "Limite d'importation d'appareils atteinte. Vous ne pouvez pas importer plus de 100 appareils.",
        "Device model and task type compatibility was updated.": "La compatibilité entre les modèles d'appareils et les types de tâches a été mise à jour.",
        "Device model was created.": "Le modèle d'appareil a été créé.",
        "Device model was deleted.": "Le modèle de dispositif a été supprimé.",
        "Device model was updated.": "Le modèle de l'appareil a été mis à jour.",
        "Device not found": "Appareil introuvable.",
        "Device Transfer job was created. Devices will be transfered shortly.": "La tâche de transfert des appareils a été créée. Les appareils seront transférés sous peu.",
        "Device was added.": "Un appareil a été ajouté.",
        "Device was deleted.": "L'appareil a été supprimé.",
        "Device was updated.": "L'appareil a été mis à jour.",
        "Email or password is incorrect.": "L'adresse e-mail ou le mot de passe que vous avez saisi est incorrect.",
        "Failed to create Product code": "Échec de la création du code produit.",
        "Failed to delete Product code": "Impossible de supprimer le code produit.",
        "Failed to import devices.": "Échec de l'importation des appareils.",
        "Failed to Read Product code": "Échec de la lecture du code produit.",
        "Failed to retry failed tasks": "Échec de la réinitialisation des tâches ayant échoué.",
        "Failed to update Product code": "Échec de la mise à jour du code produit.",
        "Failed to update task for retry": "Échec de la nouvelle tentative de la tâche ayant échoué.",
        "Field is not valid": "Le champ n'est pas valide.",
        "File description is too long. Max 255 characters allowed.": "La description du fichier est trop longue. 255 caractères maximum autorisés.",
        "File exceeds entries limit of 10000.": "Le fichier dépasse la limite d'entrée de 10 000.",
        "File must not contain duplicated IMEIs": "Le fichier ne doit pas contenir d'IMEI en double.",
        "File must not contain IMEIs that already exist in database.": "Le fichier ne doit pas contenir d'IMEI déjà présents dans la base de données.",
        "File must not contain invalid IMEIs": "Le fichier ne doit pas contenir d'IMEI invalides.",
        "File name is too long. Max 255 characters allowed.": "Le nom du fichier est trop long. 255 caractères maximum autorisés.",
        "File name should not contain illegal characters or symbols": "Le nom du fichier ne peut contenir aucun caractère spécial.",
        "File not found": "Fichier introuvable.",
        "File was deleted.": "Le fichier a été supprimé.",
        "File was successfully uploaded.": "Le fichier a été téléchargé avec succès.",
        "File was updated.": "Le fichier a été mis à jour.",
        "File was uploaded. Devices will be imported shortly.": "Le fichier a été téléchargé. Les appareils seront importés sous peu.",
        "File will be created shortly. Check files in a second.": "Le fichier sera créé sous peu. Vérifiez les fichiers dans une seconde.",
        "Firmware already exists in global files.": "",
        "Firmware bundle already exists in global files.": "",
        "Firmware file size can't be zero": "La taille des fichiers du micrologiciel ne peut pas être nulle.",
        "First device in file not found.": "Premier appareil dans le fichier introuvable.",
        "Forbidden": "Interdit.",
        "Group name already exist.": "Le nom du groupe existe déjà.",
        "Group was added.": "« {{group}} » créé avec succès.",
        "Group was created.": "Un groupe a été créé.",
        "Group was deleted.": "Le groupe a été supprimé.",
        "Group was updated.": "Le groupe a été mis à jour.",
        "Invalid device bulk update attribute": "Attribut de mise à jour groupée des appareils non valide.",
        "Invalid email address.": "Adresse e-mail non valide.",
        "Invalid file contents": "Contenu de fichier invalide.",
        "Invalid file name": "Nom de fichier non valide.",
        "Invalid invitation token.": "Jeton d'invitation non valide.",
        "Invalid token": "Jeton invalide.",
        "Invalid token length": "Longueur du jeton non valide.",
        "Internal Server Error": "Erreur interne du serveur.",
        "Internal users must sign in using Microsoft Entra ID.": "",
        "License was deleted.": "La licence a été supprimée.",
        "License was updated.": "La licence a été mise à jour.",
        "Maximum companies hierarchy depth exceeded": "Profondeur maximale de la hiérarchie des entreprises dépassée",
        "Maximum device group size exceeded.": "Taille maximale du groupe d'appareils dépassée.",
        "Method Not Allowed": "Méthode non autorisée.",
        "Network Error": "Erreur réseau.",
        "No changes made": "Aucune modification n'a été apportée.",
        "No resources found.": "Aucune ressource trouvée.",
        "not allowed to affect batch": {
            "description": "Veuillez vous assurer que vous contrôlez la société de l'utilisateur qui a créé ce groupe de tâches.",
            "title": {
                "approve": "Vous n'êtes pas autorisé à approuver ce lot.",
                "discard": "Vous n'êtes pas autorisé à supprimer ce lot."
            }
        },
        "Not Found": "Introuvable.",
        "Notification was deleted.": "La notification a été supprimée.",
        "notify when done title": "Cela peut prendre un certain temps. Appuyez sur le bouton ci-dessous pour fermer cet écran et vous recevrez une notification lorsque l'opération sera terminée.",
        "Obd record was created.": "Un enregistrement OBD a été créé.",
        "Obd record was updated.": "L'enregistrement OBD a été mis à jour.",
        "offline license added": "La licence hors ligne « {{name}} » a été ajoutée avec succès.",
        "Offline license was deleted.": "La licence hors ligne a été supprimée.",
        "Only id_list source is supported.": "Seule la source id_list est prise en charge.",
        "Only users with Teltonika email can be invited into internal companies.": "Seuls les utilisateurs disposant d'une adresse e-mail Teltonika peuvent être invités à rejoindre les entreprises internes.",
        "Only users with Teltonika email can be moved into internal companies.": "Seuls les utilisateurs disposant d'une adresse e-mail Teltonika peuvent être transférés vers des entreprises internes.",
        "Parent company cannot be a descendant of the updated company.": "La société mère ne peut pas être une descendante de la société mise à jour.",
        "Password reset link was sent to Your email.": "Un lien pour réinitialiser votre mot de passe a été envoyé à votre adresse e-mail.",
        "Password reset token is invalid, expired or related user no longer exists.": "Le jeton de réinitialisation du mot de passe n'est pas valide, a expiré ou l'utilisateur n'existe plus.",
        "Password was changed.": "Le mot de passe a été modifié.",
        "product code added": "Le code produit « {{code}} » a été ajouté avec succès.",
        "Product code is too long. Max 200 characters allowed.": "Le code produit est trop long. 200 caractères maximum autorisés.",
        "ProductCode already exists.": "Le code produit existe déjà.",
        "ProductCode not found": "Code produit introuvable.",
        "Product code was deleted.": "Le code produit a été supprimé.",
        "Product code was updated.": "Le code produit a été mis à jour.",
        "Retry failed tasks job was created": "Une tâche de réessai des tâches échouées a été créée.",
        "Role cannot be set for an internal user.": "Il n'est pas possible de définir un rôle pour un utilisateur interne.",
        "Role was created.": "Le rôle a été créé.",
        "Role was deleted.": "Le rôle a été supprimé.",
        "Role was updated.": "Le rôle a été mis à jour.",
        "selected company changed": "La société sélectionnée a été modifiée.",
        "Selected firmware bundle is not supported by the device.": "Le pack de micrologiciels sélectionné n'est pas pris en charge par l'appareil.",
        "Server Error": "Erreur serveur.",
        "SMS was sent.": "Un SMS a été envoyé.",
        "Something went wrong while saving a new password.": "Une erreur s'est produite lors de l'enregistrement d'un nouveau mot de passe.",
        "Successfully logged out.": "Déconnexion réussie.",
        "System Admin user level is required in order to perform this action.": "Le niveau d'utilisateur « Administrateur système » est requis pour effectuer cette action.",
        "Target company cannot be a descendant of source company.": "La société cible ne peut pas être une descendante de la société source.",
        "Task create limit exceeded.": "Vous ne pouvez pas créer de groupe de tâches pour plus de 100 000 appareils.",
        "Task type is not retriable": "Le type de tâche n'est pas réutilisable",
        "Task was added.": "Une tâche a été ajoutée.",
        "task was created": "La tâche a été créée pour {{imei}} (« {{taskType}} »). La tâche se trouve sur la page « Appareils » sous « Tâches » dans les détails de l'appareil.",
        "Task was updated.": "La tâche a été mise à jour.",
        "Tasks were approved": "Les tâches ont été approuvées.",
        "The given data was invalid.": "Les données fournies n'étaient pas valides.",
        "time zone changed": "Le fuseau horaire a été modifié.",
        "Token cannot be null or empty": "Le jeton ne peut être ni nul ni vide.",
        "token created": "Le jeton API a été créé avec succès.",
        "Token has expired": "Le jeton a expiré.",
        "Token's and token's owner companies do not match": "Les jetons et les sociétés propriétaires des jetons ne correspondent pas.",
        "Token was deleted.": "Le jeton a été supprimé.",
        "Too many resources in the request": "Trop de ressources dans la requête",
        "Too Many Requests": "Trop de requêtes.",
        "Transfer token created": "Jeton de transfert créé.",
        "tutorial completed": "",
        "Two factor authentication is already activated for the user.": "L'authentification à deux facteurs est déjà activée pour l'utilisateur.",
        "Two factor authentication successfully disabled.": "Authentification à deux facteurs désactivée avec succès.",
        "Unable to send SMS. This device does not have a GSM number assigned.": "Impossible d'envoyer des SMS. Cet appareil ne dispose pas d'un numéro GSM attribué.",
        "Unable to validate Your request.": "Impossible de valider votre demande.",
        "Unauthenticated.": "Non authentifié.",
        "Unauthorized": "Non autorisé.",
        "User access level is not valid": "Le niveau d'accès utilisateur n'est pas valide",
        "User invitation was revoked": "Invitation annulée avec succès.",
        "User invitation was re-sent": "L'invitation utilisateur a été renvoyée.",
        "User is already in the system.": "L'utilisateur est déjà dans le système.",
        "User was created.": "Utilisateur créé.",
        "User was deleted.": "L'utilisateur a été supprimé.",
        "User was invited.": "Invitation utilisateur envoyée avec succès.",
        "User was updated": "L'utilisateur a été mis à jour.",
        "Users count limit exceeded.": "Limite d'utilisateurs dépassée.",
        "Your password has been changed.": "Votre mot de passe a été modifié."
    },
    "General": {
        "0": "Utilisateur",
        "5": "Assistance",
        "10": "Admin",
        "15": "Gestionnaire administratif",
        "19": "",
        "20": "Utilisateur du système",
        "99": "Super utilisateur",
        "--- START-OF-PERMISSIONS ---": "",
        "Company.Create": "Création d'entreprise",
        "Company.Delete": "Suppression de l'entreprise",
        "Company.Merge": "Fusion d'entreprises",
        "Company.Update": "Actualités de l'entreprise",
        "Device.Export": "Exportation des appareils",
        "Device.Read": "Lecture des appareils",
        "Device.SecretsRead": "",
        "Device.Transfer": "Transfert d'appareils",
        "Device.Unlock": "Déverrouillage des appareils",
        "Device.Update": "Mise à jour des appareils",
        "DeviceGroup.Create": "Création de groupes d'appareils",
        "DeviceGroup.Delete": "Suppression de groupes d'appareils",
        "DeviceGroup.Read": "Lecture de groupes d'appareils",
        "DeviceGroup.Update": "Mise à jour du groupe d'appareils",
        "File.Create": "Création de fichiers",
        "File.Delete": "Suppression de fichiers",
        "File.Download": "Téléchargement de fichiers",
        "File.Read": "Lecture de fichiers",
        "File.TctWebAccess": "TCT web",
        "File.Update": "Mise à jour des fichiers",
        "Role.Create": "Création de rôles",
        "Role.Delete": "Suppression de rôle",
        "Role.Read": "Rôle lu",
        "Role.Update": "Mise à jour des rôles",
        "Task.Create": "Création de tâches",
        "Task.Read": "Lecture des tâches",
        "Task.Retry": "Réessai de tâche",
        "Task.Update": "Mise à jour des tâches",
        "TaskGroup.Read": "Lecture du groupe de tâches",
        "TctIntegration.Access": "Intégration TCT",
        "Token.Create": "Création de jetons",
        "Token.Delete": "Suppression de jetons",
        "Token.Read": "Lecture de jetons",
        "User.Create": "",
        "User.Delete": "Suppression d'utilisateurs",
        "User.Read": "Lecture par l'utilisateur",
        "User.Update": "Mise à jour utilisateur",
        "--- END-OF-PERMISSIONS ---": "",
        "1-wire authorization list": "Liste d'autorisation 1-Wire",
        "1_wire_authorization_list": "Liste d'autorisation 1-Wire",
        "Active": "Actif",
        "adas_firmware": "Micrologiciel ADAS",
        "apx_firmware": "Micrologiciel APX",
        "assign can package": "Attribuer un package CAN",
        "assigned package": "Forfait attribué",
        "automatic": "Automatique",
        "banner management": "",
        "batches": "Groupes de tâches",
        "black_box": "Boîte noire",
        "ble_dtb": "BLE DTB",
        "ble_fw": "Micrologiciel BLE",
        "blue_nrg": "Micrologiciel BlueNRG",
        "BluetoothAuthorizationList": "",
        "bluetooth authorization list": "Liste d'autorisation Bluetooth",
        "bluetooth_authorization_list": "Liste d'autorisation Bluetooth",
        "bluetooth password": "",
        "boolean filtered value name": {
            "task_support": {
                "false": "Incompatible",
                "true": "Compatible"
            },
            "web_editor_support": {
                "false": "TCT web non pris en charge",
                "true": "Prise en charge TCT web"
            }
        },
        "can": "CAN",
        "can adapter name": "Nom de l'adaptateur CAN",
        "can bootstring": "Bootstring",
        "can configuration": "Configuration OEM",
        "can_debug_log": "Journal de débogage CAN",
        "can oem file package": "Pack de fichiers OEM",
        "can oem file vehicle": "Véhicule de fichiers OEM",
        "can package": "Pack OEM",
        "can program number": "Numéro de programme CAN",
        "can revision": "Révision CAN",
        "can software date": "Date du logiciel CAN",
        "can type": "Type CAN",
        "Cancelled": "Annulé",
        "cancel task": "Annuler la tâche",
        "can_chip_firmware": "Micrologiciel FM CAN Chip",
        "carrier_advance_firmware": "Micrologiciel Carrier Advance",
        "carrier_advance_settings": "Paramètres avancés du Carrier Advance",
        "carrier_apx_firmware": "Micrologiciel Carrier APX",
        "carrier_apx_settings": "Paramètres Carrier APX",
        "carrier_extractions": "Carrier extractions",
        "carrier_logger_files": "Fichiers de l'enregistreur de température du Carrier",
        "certificate": "Certificat",
        "click for more details": "Cliquez ici pour plus de détails",
        "client ip": "IP client",
        "clone model": "Modèle de clonage d'appareil",
        "collapse menu": "Réduire le menu",
        "companies": "Entreprises",
        "company": "Entreprise",
        "company level": "Au niveau de l'entreprise",
        "company type": "Type d'entreprise",
        "company name": "Nom de l'entreprise",
        "Completed": "Terminé",
        "Completed with errors": "Terminé avec des erreurs",
        "configuration": "Configuration",
        "configuration_36": "Configuration (FM36)",
        "configuration_64": "Configuration (FMB64)",
        "crash_dump": "Journal des vidages sur incident",
        "created at": "Créé à",
        "created by": "Créé par",
        "custom": "Personnalisé",
        "custom resource limits": "Limites de ressources personnalisées",
        "dashboard": "Tableau de bord",
        "delete desktop license": "Supprimer la licence pour ordinateur de bureau",
        "delete offline license": "Supprimer la licence hors ligne",
        "desktopLicenses": "Licences Desktop",
        "device_export_file_csv": "Fichier d'exportation des appareils (.csv)",
        "device_export_file_xlsx": "Fichier d'exportation des appareils (.xlsx)",
        "deviceModels": "Modèles",
        "deviceModelTaskCompatibilities": "Compatibilités",
        "device_transfer_report": "Rapport de transfert des appareils",
        "device group": "Groupe",
        "DeviceImportFile": "Fichier d'importation des appareils",
        "devices": "Appareils",
        "download file": "Télécharger le fichier",
        "download offline license": "Télécharger la licence hors ligne",
        "dsm_firmware": "Micrologiciel DSM",
        "dtb": "DTB",
        "edit compatibility": "Modifier la compatibilité des appareils",
        "edit model": "Modifier le modèle de l'appareil",
        "edit company": "Modifier l'entreprise",
        "edit desktop license": "Modifier la licence pour desktop",
        "edit device": "Modifier l'appareil",
        "edit file": "Modifier le fichier",
        "edit group": "Modifier le groupe",
        "edit in tct web": "Modifier dans TCT web",
        "edit in tct web disabled": "La modification dans TCT web n'est disponible que pour les entreprises de niveau Premium.",
        "edit product code": "Modifier le code produit",
        "edit role": "Modifier le rôle",
        "edit smart group": "Modifier le groupe intelligent",
        "edit user": "Modifier l'utilisateur",
        "Empty": "Vide",
        "enter here": "Entrez ici",
        "exception_info": "Informations sur les exceptions",
        "Executing": "Exécution",
        "expand menu": "Développer le menu",
        "Expired": "Expiré",
        "Factory": "",
        "Failed": "Échec",
        "file": "Fichier",
        "file data": "Données de fichiers",
        "files": "Fichiers",
        "file deleted": "Le fichier a été supprimé",
        "firmware": "Micrologiciel",
        "firmware_36": "Micrologiciel (FM36)",
        "firmware_64": "Micrologiciel (FMB64)",
        "Fmx": "FMx",
        "Fota": "",
        "Ft": "FT",
        "fw_bundle": "Ensemble de micrologiciels",
        "fw_bundle_ble": "Bundle - Micrologiciel BLE",
        "fw_bundle_ble_dtb": "Ensemble - BLE DTB",
        "fw_bundle_can": "Ensemble - Micrologiciel CAN",
        "fw_bundle_can_dtb": "Bundle - CAN DTB",
        "fw_bundle_dtb": "Bundle - DTB principal",
        "fw_bundle_mainfw": "Ensemble - Micrologiciel principal",
        "generic": "",
        "global_configuration": "Configuration globale",
        "global_firmware": "Micrologiciel global",
        "gnssm_download_assistant": "Assistant de téléchargement GNSS-M",
        "gnssm_firmware": "Micrologiciel GNSS-M",
        "group": "Groupe",
        "groups": "Groupes d'appareils",
        "hardware key": "Clé matérielle",
        "id": "ID",
        "id_collection_file": "Fichier de collecte d'identifiants",
        "imei restriction": "Restriction IMEI",
        "Inactive": "Inactif",
        "Invalid": "Non valide",
        "invalid model": "Modèle non valide",
        "invalid model_name": "Modèle non valide",
        "InvitationExpired": "Invitation expirée",
        "InvitationPending": "Invitation en attente",
        "Legacy": "Héritage",
        "legacy model": "Modèle traditionnel",
        "legacy model_platform": "Plateforme héritée",
        "legacy platform": "Plateforme héritée",
        "license has expired": "La licence a expiré",
        "loading": "Chargement",
        "log": "Journal",
        "MainConfiguration": "",
        "main configuration": "",
        "manual": "Manuel",
        "ManualGeofenceList": "",
        "manual geofence list": "Liste manuelle des scénarios de géorepérage",
        "manual_geofence_list": "Liste manuelle des scénarios de géorepérage",
        "meig_modem_firmware": "Micrologiciel du modem MeiG",
        "menu": "Menu",
        "modem version": "Version modem",
        "netprisma_modem_firmware": "Micrologiciel du modem NETPRISMA",
        "nmea_log": "Journal NMEA",
        "no": "Non",
        "no results": "Aucun résultat initial trouvé",
        "no results description": "Dès que {{name}} sera téléchargé sur FOTA WEB, vous pourrez voir les données ici",
        "not assigned": "Non attribué",
        "not assigned configuration_file_id": "Configuration non attribuée",
        "not assigned current_configuration": "Configuration non attribuée",
        "not assigned current_firmware": "Firmware non attribué",
        "not assigned firmware_file_id": "Firmware non attribué",
        "not assigned group_id": "Groupe non attribué",
        "not assigned model": "Modèle non attribué",
        "not assigned spec_id": "Spec ID non attribué",
        "not assigned task_type": "Type de tâche non attribué",
        "obd_chip_firmware": "Micrologiciel FM OBD Chip",
        "obd chip firmware version": "Version du micrologiciel de la puce OBD",
        "Offline": "Hors ligne",
        "offline licenses": "Licences hors ligne",
        "Online": "En ligne",
        "OneWireAuthorizationList": "",
        "open in tct": "",
        "or": "ou",
        "other": "Autres",
        "Pending": "En attente",
        "Pending approval": "En attente d'approbation",
        "permission disabled": "Désactivé",
        "permission enabled": "Activé",
        "productCodes": "Codes produit",
        "psub": "Fichier d'abonnement",
        "quectel_fw": "Micrologiciel du modem Quectel (quectel_fw)",
        "quectel_modem_firmware": "Micrologiciel du modem Quectel",
        "resend invite": "Renvoyer l'invitation",
        "restricted": "Restrictions",
        "retry": "Réessayer",
        "roles": "Rôles et autorisations",
        "Running": "En cours d'exécution",
        "RxAutoscan": "Recevoir le fichier CAN par analyse automatique",
        "RxBlackBox": "Recevoir la boîte noire",
        "RxBluetoothAuthorizationList": "Recevoir la liste des autorisations Bluetooth",
        "RxCanDebugLog": "Réception du journal de débogage CAN",
        "RxCarrierExtractions": "Télécharger les Carrier extractions",
        "RxCarrierLoggerFiles": "Télécharger les fichiers de l'enregistreur de température du Carrier",
        "RxConfiguration": "Recevoir la configuration",
        "RxCrashDump": "Recevoir le journal des vidages sur incident",
        "RxExceptionInfo": "Recevoir les informations d'exception",
        "RxLog": "Recevoir le journal interne",
        "RxManualGeofenceList": "Recevoir la liste des scénarios de géorepérage manuels",
        "RxNmeaLog": "Recevoir le journal NMEA",
        "RxOneWireAuthorizationList": "Recevoir la liste d'autorisation 1-Wire",
        "RxWdLog": "Recevoir le journal Watch-Dog (WD)",
        "select company": "Sélectionner une entreprise",
        "SetBindSim": "Lier l'appareil à la ou aux cartes SIM actuelles",
        "SetBluetoothPassword": "",
        "SetDisableFeature": "Désactiver la fonctionnalité",
        "SetEnableFeature": "Activer la fonctionnalité",
        "SetForceLockSim": "Verrouillage forcé de la carte SIM",
        "SetUnbindSim": "Désassocier un appareil d'une ou plusieurs cartes SIM",
        "simcom_modem_firmware": "",
        "SmsGprs": "",
        "status": "Statut",
        "task details": "Détails de la tâche",
        "task groups": "Groupes de tâches",
        "tasks": "Groupes de tâches",
        "tasksCompatibility": "Compatibilité des tâches",
        "task type": "Type de tâche",
        "Tct": "",
        "time zone": "Fuseau horaire",
        "total": "Total",
        "tutorials": "Tutoriels",
        "TxAdasFirmware": "Téléchargement du micrologiciel ADAS",
        "TxAgpsMt3333": "Transfert de fichiers AGPSM",
        "TxAgpsQuectelL89": "Transfert de fichiers AGPSQ",
        "TxAutoscanCanConfiguration": "Télécharger le fichier OEM d'analyse automatique",
        "TxBleFirmware": "Téléchargement du micrologiciel BLE",
        "TxBlueNrgFirmware": "Télécharger le micrologiciel BlueNrg",
        "TxBluetoothAuthorizationList": "Télécharger la liste d'autorisation Bluetooth",
        "TxBundleBle": "Télécharger le micrologiciel BLE",
        "TxBundleBleDtb": "Télécharger BLE DTB",
        "TxBundleCan": "Téléchargement du micrologiciel CAN",
        "TxBundleCanDtb": "Télécharger CAN DTB",
        "TxBundleDtb": "Télécharger le fichier DTB principal",
        "TxBundleFirmware": "Télécharger le micrologiciel principal",
        "TxCanAdapterModeChange": "Modifier le mode de l'adaptateur CAN externe",
        "TxCanAdapterModeChangeInternal": "Modifier le mode de l'adaptateur CAN interne",
        "TxCanAdapterUpdate": "Téléchargement du micrologiciel de l'adaptateur CAN",
        "TxCanAdapterUpdateInternal": "Mise à jour de l'adaptateur CAN interne",
        "TxCanChipFirmware": "Télécharger le micrologiciel de la puce CAN FMXY50",
        "TxCanConfiguration": "Télécharger le fichier OEM",
        "TxCarrierAdvanceFirmware": "Mise à jour du micrologiciel Carrier Advance",
        "TxCarrierAdvanceSettings": "Mettre à jour les paramètres Carrier Advance",
        "TxCarrierApxFirmware": "Mise à jour du micrologiciel Carrier APX",
        "TxCarrierApxSettings": "Mise à jour des paramètres Carrier APX",
        "TxConfiguration": "Configuration du téléchargement",
        "TxDsmFirmware": "Télécharger le micrologiciel DSM",
        "TxDtb": "Télécharger DTB",
        "TxFirmware": "Téléchargement du micrologiciel",
        "TxFirmwareBundle": "Télécharger le conteneur de micrologiciels",
        "TxFirmwareBundleParts": "Télécharger le pack de micrologiciels",
        "TxFotaCertificate": "Mise à jour du certificat FOTA",
        "TxGenericFile": "",
        "TxGNSSMDownloadAssistant": "Télécharger GNSS-M Assistant de téléchargement",
        "TxGNSSMFirmware": "Téléchargement du micrologiciel GNSS-M",
        "TxManualGeofenceList": "Télécharger la liste des scénarios de géorepérage manuels",
        "TxMeigModemDeltaFirmware": "Télécharger le micrologiciel du modem MeiG Delta",
        "TxNetprismaModemDeltaFirmware": "Télécharger le micrologiciel du modem NETPRISMA Delta",
        "TxObdChipFirmware": "Mise à jour de la puce OBD",
        "TxObdConfig": "Transfert du fichier de configuration OBD",
        "TxOneWireAuthorizationList": "Télécharger la liste d'autorisation 1-Wire",
        "TxPSub": "Transférer le fichier d'abonnement",
        "TxQuectelModemDeltaFirmware": "Télécharger le micrologiciel du modem Quectel Delta",
        "TxSimcomModemDeltaFirmware": "",
        "TxUserCertificate": "Télécharger le certificat TLS de l'utilisateur",
        "users": "Utilisateurs",
        "Unknown": "Inconnu",
        "unknown": "Inconnu",
        "unknown model_platform": "Plateforme inconnue",
        "unknown origin": "",
        "unknown platform": "Plateforme inconnue",
        "unrestricted": "Sans restriction",
        "Verifying": "Vérification",
        "vin": "VIN",
        "vip status": "Statut VIP",
        "wd_log": "Journal WD",
        "yes": "Oui"
    },
    "Maintenance": {
        "title": "Patientez ! Nous sommes en maintenance."
    },
    "Notifications": {
        "description": {
            "{{BackgroundActionType}} failed due to server error": "{{BackgroundActionType}} a échoué en raison d'une erreur serveur.",
            "Cancel tasks action failed. Invalid request scope. Resources must belong to single root.": "Vous n'êtes pas autorisé à annuler toutes les tâches sélectionnées. Certaines tâches sont associées à des ressources provenant de différentes entreprises.",
            "Cancel tasks action failed. No resources found.": "Aucune tâche ne correspond à votre sélection. Veuillez vérifier votre sélection et réessayer.",
            "Company \"{{SourceCompanyName}}\" ({{SourceCompanyId}}) merged into \"{{TargetCompanyName}}\" (<TargetCompanyId>).": "La société « {{SourceCompanyName}} » ({{SourceCompanyId}}) a fusionné avec « {{TargetCompanyName}} » ({{TargetCompanyId}}).",
            "Company merge failed. Companies '{{SourceCompanyId}}' and '{{TargetCompanyId}}' cannot be merged due to incompatible settings or permissions.": "Échec de la fusion des entreprises. Les entreprises « {{SourceCompanyId}} » et « {{TargetCompanyId}} » ne peuvent pas être fusionnées en raison de paramètres ou d'autorisations incompatibles.",
            "Create device group tasks action failed. No resources found.": "Échec de la création de tâches pour le groupe intelligent. Veuillez réessayer de réattribuer le fichier.",
            "{{CreatedTaskCount}} task(s) created for device group ID:{{GroupId}} devices.": "{{CreatedTaskCount}} tâche(s) créée(s) pour le groupe d'appareils ID :{{GroupId}} appareils.",
            "Create tasks action failed. Invalid request scope. Resources must belong to single root.": "Vous n'êtes pas autorisé à créer des tâches pour tous les appareils sélectionnés. Certains appareils appartiennent à différentes entreprises.",
            "Create tasks action failed. No resources found.": "Aucun appareil ne correspond à votre sélection. Veuillez vérifier votre sélection d'appareils et réessayer.",
            "Create tasks action failed. No resources processed.": "Échec du traitement des appareils sélectionnés. Veuillez essayer de créer à nouveau un groupe de tâches.",
            "Delete companies action failed. Invalid request scope. Resources must belong to single root.": "Vous n'êtes pas autorisé à supprimer toutes les entreprises sélectionnées. Certaines entreprises ne relèvent pas de votre gestion directe.",
            "Delete companies action failed. No resources found.": "Aucune entreprise ne correspond à votre sélection. Veuillez vérifier votre sélection d'entreprises et réessayer.",
            "Delete files action failed. Invalid request scope. Resources must belong to single root.": "Vous n'êtes pas autorisé à supprimer tous les fichiers sélectionnés. Certains fichiers sont associés à des ressources provenant de différentes entreprises.",
            "Delete files action failed. No resources found.": "Aucun fichier ne correspond à votre sélection. Veuillez vérifier votre sélection de fichiers et réessayer.",
            "Delete groups action failed. Invalid request scope. Resources must belong to single root.": "Vous n'êtes pas autorisé à supprimer tous les groupes d'appareils sélectionnés. Certains groupes d'appareils contiennent des ressources provenant de différentes entreprises.",
            "Delete groups action failed. No resources found.": "Aucun groupe d'appareils ne correspond à votre sélection. Veuillez vérifier votre sélection de groupes d'appareils et réessayer.",
            "Delete product codes action failed. No resources found.": "Aucun code produit ne correspond à votre sélection. Veuillez vérifier votre sélection de codes produits et réessayer.",
            "Delete users action failed. Invalid request scope. Resources must belong to single root.": "Vous n'êtes pas autorisé à supprimer tous les utilisateurs sélectionnés. Certains utilisateurs appartiennent à différentes entreprises.",
            "Delete users action failed. No resources found.": "Aucun utilisateur ne correspond à votre sélection. Veuillez vérifier votre sélection d'utilisateurs et réessayer.",
            "Device group ID:{{GroupId}} move failed. Target company ID:{{TargetCompanyId}} cannot be found.": "",
            "Device group ID:{{GroupId}} successfully moved to company ID:{{TargetCompanyId}}.": "",
            "{{DevicesCount}} device(s) exported to \"{{Filename}}\".": "{{DevicesCount}} appareil(s) exporté(s) vers « {{Filename}} ».",
            "{{DevicesCount}} device(s) imported.": "{{DevicesCount}} appareil(s) importé(s).",
            "{{DevicesProcessedCount}} device(s) processed, {{TasksCreatedCount}} task(s) created.": "{{DevicesProcessedCount}} appareil(s) traité(s), {{TasksCreatedCount}} tâche(s) créée(s).",
            "Export devices action failed. No resources found.": "Aucun appareil ne correspond à votre sélection. Veuillez vérifier votre sélection d'appareils et réessayer.",
            "{{FailedTaskCount}} task(s) returned to pending in task group {{BatchId}}.": "{{FailedTaskCount}} tâche(s) renvoyée(s) en attente dans le groupe de tâches {{BatchId}}.",
            "Invalid request scope. Resources must belong to single root.": "Portée de la requête non valide. Les ressources doivent appartenir à une seule racine.",
            "Move device group action failed. No resources found.": "",
            "{{ProcessedCount}} companies deleted.": "{{ProcessedCount}} entreprises supprimées.",
            "{{ProcessedCount}} device group(s) deleted.": "{{ProcessedCount}} groupe(s) d'appareils supprimé(s).",
            "{{ProcessedCount}} device attribute(s) updated.": "{{ProcessedCount}} attribut(s) d'appareil(s) mis à jour.",
            "{{ProcessedCount}} device model(s) deleted.": "{{ProcessedCount}} modèle(s) d'appareil(s) supprimé(s).",
            "{{ProcessedCount}} device(s) updated.": "{{ProcessedCount}} appareil(s) mis à jour.",
            "{{ProcessedCount}} file(s) deleted.": "{{ProcessedCount}} fichier(s) supprimé(s).",
            "{{ProcessedCount}} product code(s) deleted.": "{{ProcessedCount}} code(s) produit(s) supprimé(s).",
            "{{ProcessedCount}} task(s) canceled.": "{{ProcessedCount}} tâche(s) annulée(s).",
            "{{ProcessedCount}} task(s) updated.": "{{ProcessedCount}} tâche(s) mise(s) à jour.",
            "{{ProcessedCount}} user(s) deleted.": "{{ProcessedCount}} utilisateur(s) supprimé(s).",
            "Retry tasks action failed. No resources found.": "Aucune tâche ne correspond à votre sélection. Veuillez vérifier votre sélection et réessayer.",
            "Transfer devices action failed. Invalid request scope. Resources must belong to single root.": "Vous n'êtes pas autorisé à transférer tous les appareils sélectionnés. Certains appareils appartiennent à différentes entreprises.",
            "Transfer devices action failed. No resources found.": "Aucun appareil ne correspond à votre sélection. Veuillez vérifier votre sélection d'appareils et réessayer.",
            "Transfer devices action failed. No resources processed.": "Échec du traitement des appareils sélectionnés. Veuillez réessayer de transférer les appareils.",
            "{{TransferredDevicesCount}} of {{TotalDevicesToTransfer}} device(s) transferred.": "{{TransferredDevicesCount}} des {{TotalDevicesToTransfer}} appareils ont été transférés.",
            "Update devices action failed. Invalid request scope. Resources must belong to single root.": "Vous n'êtes pas autorisé à mettre à jour tous les appareils sélectionnés. Certains appareils appartiennent à différentes entreprises.",
            "Update devices action failed. No resources found.": "Aucun appareil ne correspond à votre sélection. Veuillez vérifier votre sélection d'appareils et réessayer.",
            "Update devices attributes action failed. Invalid request scope. Resources must belong to single root.": "Vous n'êtes pas autorisé à mettre à jour les attributs de tous les appareils sélectionnés. Certains appareils appartiennent à différentes entreprises.",
            "Update devices attributes action failed. No resources found.": "Aucun appareil ne correspond à votre sélection. Veuillez vérifier votre sélection d'appareils et réessayer.",
            "Update tasks action failed. Invalid request scope. Resources must belong to single root.": "Vous n'êtes pas autorisé à mettre à jour toutes les tâches sélectionnées. Certaines tâches sont associées à des ressources provenant de différentes entreprises.",
            "Update tasks action failed. No resources found.": "Aucune tâche ne correspond à votre sélection. Veuillez vérifier votre sélection et réessayer.",
            "User access is scheduled to expire at {{ExpiresAt}} UTC. To maintain uninterrupted service, please contact your company's administrators immediately to request an extension.": ""
        },
        "no notifications": "Aucune notification",
        "notifications": "Notifications",
        "notifications will be listed": "Toutes les nouvelles notifications seront répertoriées ici",
        "remove notification": "Supprimer la notification",
        "see previous notifications": "Voir les notifications précédentes",
        "timestamps": {
            "days ago": "Il y a {{days}} jours",
            "hours ago": "Il y a {{hours}} heures",
            "minutes ago": "Il y a {{minutes}} min",
            "moments ago": "Il y a quelques instants"
        },
        "title": {
            "BackgroundActionFailed": "Action échouée",
            "CompaniesSuccessfullyDeleted": "Entreprises supprimées avec succès",
            "CompanyBulkDeleteFailed": "Une erreur s'est produite lors de la suppression des entreprises",
            "CompanyLevelChanged": "Changement au niveau de l'entreprise",
            "CompanyLevelDowngradeReminder": "Prochaine rétrogradation au niveau de l'entreprise",
            "CompanyMergeFailed": "Une erreur s'est produite lors de la fusion des entreprises",
            "CompanySuccessfullyMerged": "Entreprises fusionnées avec succès",
            "DeviceAttributesSuccessfullyUpdated": "Attributs des appareils mis à jour avec succès",
            "DeviceBulkAttributeUpdateFailed": "Une erreur s'est produite lors de la mise à jour des attributs de l'appareil",
            "DeviceBulkUpdateFailed": "Une erreur s'est produite lors de la mise à jour des appareils",
            "DeviceExportFailed": "Une erreur s'est produite lors de l'exportation des appareils",
            "DeviceGroupMoveFailed": "",
            "DeviceGroupsSuccessfullyDeleted": "Groupes d'appareils supprimés avec succès",
            "DeviceGroupSuccessfullyMoved": "",
            "DeviceGroupTasksCreateFailed": "Une erreur s'est produite lors de la création des tâches du groupe intelligent",
            "DeviceGroupTasksSuccessfullyCreated": "Tâches Smart Group créées avec succès",
            "DeviceModelBulkDeleteFailed": "Une erreur s'est produite lors de la suppression des modèles d'appareils",
            "DeviceModelsSuccessfullyDeleted": "Modèles d'appareils supprimés avec succès",
            "DevicesSuccessfullyTransferred": "Appareils transférés avec succès",
            "DevicesSuccessfullyUpdated": "Appareils mis à jour avec succès",
            "DeviceTransferFailed": "Une erreur s'est produite lors du transfert des appareils",
            "ExportFailed": "Échec de l'exportation des ressources",
            "ExportSucceeded": "Appareils exportés avec succès",
            "FailedTasksRetryFailed": "Une erreur s'est produite lors de la réessai des tâches",
            "FailedTasksSuccessfullyRetried": "Tâches réessayées avec succès",
            "FileBulkDeleteFailed": "Une erreur s'est produite lors de la suppression des fichiers",
            "FilesSuccessfullyDeleted": "Fichiers supprimés avec succès",
            "GroupBulkDeleteFailed": "Une erreur s'est produite lors de la suppression des groupes d'appareils",
            "ImportFailed": "Échec de l'importation des ressources",
            "ImportSucceeded": "Appareils importés avec succès",
            "ProductCodeBulkDeleteFailed": "Une erreur s'est produite lors de la suppression des codes produit",
            "ProductCodesSuccessfullyDeleted": "Codes produit supprimés avec succès",
            "ResourceUpdateFailed": "Échec de la mise à jour des ressources",
            "ResourceUpdateSucceeded": "Mise à jour des ressources réussie",
            "RoleBulkDeleteFailed": "Une erreur s'est produite lors de la suppression des rôles",
            "RolesSuccessfullyDeleted": "Rôles supprimés avec succès",
            "TaskBulkCancelFailed": "Une erreur s'est produite lors de l'annulation des tâches",
            "TaskBulkCreateFailed": "Une erreur s'est produite lors de la création d'un groupe de tâches",
            "TaskBulkUpdateFailed": "Une erreur s'est produite lors de la mise à jour des tâches",
            "TaskGroupSuccessfullyCreated": "Groupe de tâches créé avec succès",
            "TasksPropagationFailed": "Échec de la propagation des tâches",
            "TasksPropagationSucceeded": "Tâche de propagation des tâches réussie",
            "TasksPropagationWarning": "La propagation des tâches s'est terminée avec des avertissements",
            "TasksSuccessfullyCanceled": "Tâches annulées avec succès",
            "TasksSuccessfullyUpdated": "Tâches mises à jour avec succès",
            "UserBulkDeleteFailed": "Une erreur s'est produite lors de la suppression d'utilisateurs",
            "UserExpireReminder": "",
            "UsersSuccessfullyDeleted": "Utilisateurs supprimés avec succès"
        }
    },
    "Permission actions": {
        "Access": "Intégration TCT",
        "Create": "Créer",
        "Delete": "Supprimer",
        "Download": "Télécharger",
        "Export": "Exporter",
        "Merge": "Fusionner",
        "Read": "Lire",
        "Retry": "Réessayer",
        "SecretsRead": "",
        "TctWebAccess": "TCT web",
        "Transfer": "Transfert",
        "Unlock": "Déverrouiller",
        "Update": "Mise à jour"
    },
    "Permission groups": {
        "company": "Entreprises",
        "device": "Appareils",
        "device group": "Groupes d'appareils",
        "file": "Fichiers",
        "role": "Rôles",
        "task": "Tâches",
        "task group": "Groupes de tâches",
        "token": "Jetons",
        "user": "Utilisateurs"
    },
    "Restrictions": {
        "feature_settings": {
            "api_token_support": {
                "input option": "Cette option est désactivée pour les utilisateurs disposant d'un niveau d'entreprise Basic.",
                "token list": "Les jetons d'intégration API sont désactivés pour les utilisateurs disposant d'un niveau d'entreprise de base."
            },
            "custom_role_support": {
                "create role": "Cette fonctionnalité est réservée aux utilisateurs disposant d'un abonnement Premium au niveau de l'entreprise.",
                "edit role": "Cette fonctionnalité ne peut être utilisée que par les utilisateurs disposant d'un niveau d'entreprise Premium. Les rôles personnalisés créés précédemment peuvent être supprimés.",
                "edit user": "Cette fonctionnalité ne peut être utilisée que par les utilisateurs disposant d'un niveau d'entreprise Premium. Les rôles personnalisés précédemment attribués peuvent être supprimés."
            },
            "task_schedule_support": {
                "table head": "Cette fonctionnalité n'est accessible qu'aux utilisateurs disposant d'un abonnement Standard ou Premium. Les tâches précédemment ajoutées avec des calendriers seront toujours exécutées."
            }
        },
        "general message": "Cette fonctionnalité est réservée aux utilisateurs disposant d'un compte d'entreprise Standard ou Premium.",
        "resource_limit_settings": {
            "tasks_per_group": "Vous ne pouvez pas créer de tâches pour plus de {{limitCount}} appareils à la fois."
        }
    },
    "Search": {
        "code": "Code",
        "description": "Description",
        "email": "E-mail",
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "model": "Modèle",
        "name": "Nom",
        "product code": "Code produit",
        "role name": "Nom du rôle",
        "serial": "Numéro de série.",
        "search by": "Rechercher par",
        "search company name": "Rechercher le nom de l'entreprise"
    },
    "Security": {
        "2FA": {
            "disable": {
                "confirmation": {
                    "description": "Vous êtes sur le point de désactiver votre authentification à deux facteurs. Cela pourrait compromettre la sécurité de votre compte FOTA WEB. Êtes-vous sûr de vouloir continuer ?",
                    "title": "Êtes-vous sûr ?"
                },
                "send email code": {
                    "enter code": "Pour des raisons de sécurité, veuillez saisir le code pour vérifier l'adresse e-mail."
                },
                "send otp code": {
                    "description": "Un code à 6 chiffres a été envoyé à votre application d'authentification. Pour des raisons de sécurité, veuillez saisir le code généré dans le champ ci-dessous.",
                    "no access": {
                        "authenticator": "Si vous n'avez plus accès à l'application d'authentification liée à ce compte, vous devez modifier votre mot de passe pour désactiver l'authentification à deux facteurs.",
                        "email": "Si vous n'avez plus accès à l'adresse e-mail associée à ce compte, vous devez modifier votre mot de passe pour désactiver l'authentification multifactorielle."
                    }
                },
                "title": "Désactiver l'authentification à deux facteurs"
            },
            "get email code": {
                "description": "Utilisez ce code sur l'écran suivant pour vérifier votre compte.",
                "description modal": "Utilisez ce code pour vérifier votre compte.",
                "title": "En appuyant sur « Envoyer le code », un code unique sera envoyé à <1>{{email}}</1>."
            },
            "get secret code": {
                "description": "Vous aurez besoin d'une application mobile d'authentification pour mener à bien ce processus, telle que l'une des suivantes :"
            },
            "select authentication type": {
                "authentication app description": "Obtenez un code unique à partir d'une application telle que Microsoft Authenticator ou Google Authenticator.",
                "description": "Pour assurer la sécurité de votre compte et des données de vos clients, veuillez utiliser l'une des options suivantes pour configurer l'authentification à deux facteurs.",
                "description modal": "Sélectionnez votre méthode d'authentification préférée.",
                "email": "E-mail",
                "email description": "Nous vous enverrons un code à usage unique à votre adresse e-mail chaque fois que vous tenterez de vous connecter.",
                "recommended": "Recommandé",
                "title": "L'authentification à deux facteurs (2FA) est obligatoire pour tous les utilisateurs de FOTA WEB.",
                "title modal": "Sélectionnez la méthode d'authentification"
            },
            "send email code": {
                "description": "Veuillez saisir le code dans le champ ci-dessous, puis appuyer sur « Vérifier » pour continuer.",
                "enter code": "Veuillez saisir le code pour vérifier l'adresse e-mail.",
                "title": "Un code unique a été envoyé à <1>{{email}}</1>.",
                "verification code": "Code de vérification"
            },
            "send otp code": {
                "click to scan code": "Cliquez ici pour scanner un code QR à la place",
                "click to type code": "Cliquez ici pour saisir manuellement le code à la place",
                "incorrect code": "Code incorrect",
                "scan QR code": "Scannez le code QR dans votre application",
                "six digit code": "Code à 6 chiffres généré par votre application",
                "title": "Vous aurez besoin d'une application mobile d'authentification pour mener à bien ce processus, telle que : <1>Microsoft Authenticator</1> ou <2>Google Authenticator</2>.",
                "type text code": "Saisissez le code texte dans votre application"
            },
            "settings": {
                "description": "L'authentification à deux facteurs est une couche de sécurité supplémentaire qui vérifie votre identité à l'aide d'un élément que vous connaissez (mot de passe) et d'un élément que vous possédez (téléphone, clé de sécurité, e-mail).",
                "disabled": "Désactivé",
                "enabled": "Activé",
                "title": "Authentification à deux facteurs"
            },
            "success message": {
                "alert": "Authentification à deux facteurs activée avec succès.",
                "description": "Nous vous demanderons un code d'authentification chaque fois que vous vous connecterez avec votre adresse e-mail et votre mot de passe.",
                "title": "Vous avez activé avec succès l'authentification à deux facteurs.",
                "title modal": "Authentification à deux facteurs activée !"
            },
            "title": {
                "authentication app": "Application d'authentification",
                "authentication email": "E-mail d'authentification",
                "is enabled": "Authentification à deux facteurs activée.",
                "protect your account": "Protégez votre compte FOTA WEB"
            }
        },
        "delete account": {
            "confirmation": {
                "account": "",
                "banner": "",
                "cancel info": "",
                "more info": "",
                "description": "",
                "title": "",
                "verification code description": {
                    "authenticator": "",
                    "email": ""
                }
            },
            "settings": {
                "description": "",
                "title": ""
            }
        },
        "password": {
            "change password": "Modifier le mot de passe",
            "enter current password": "Entrez votre mot de passe actuel",
            "enter new password": "Entrer un nouveau mot de passe",
            "hide password": "Masquer le mot de passe",
            "repeat new password": "Répétez le nouveau mot de passe",
            "rules": {
                "lowercase letter": "Au moins une lettre minuscule (a-z)",
                "minimum characters": "Au moins 12 caractères",
                "new and current passwords must not match": "Les mots de passe nouveaux et actuels ne doivent pas être identiques",
                "new passwords must match": "Les nouveaux mots de passe doivent correspondre",
                "number": "Au moins un numéro",
                "passwords must match": "Les mots de passe doivent correspondre",
                "special symbol": "Au moins un symbole spécial (!@#$%^&*()-_=+)",
                "uppercase letter": "Au moins une lettre majuscule (A-Z)"
            },
            "settings": {
                "description": "",
                "title": ""
            },
            "show password": "Afficher le mot de passe"
        },
        "recovery codes": {
            "banner description": "",
            "banner title": "",
            "checkbox title": "",
            "download error message": "",
            "first step description": "",
            "first step title": "",
            "input field title": "",
            "print error message": "",
            "second step description": "",
            "second step title": "",
            "settings": {
                "title": "",
                "description": ""
            }
        },
        "account": "",
        "description": "",
        "security": "",
        "security and account": ""
    },
    "Settings": {
        "version": ""
    },
    "Statistics": {
        "table statistics": "Statistiques du tableau",
        "statistics message": "Les filtres du tableau affectent les statistiques affichées ci-dessous",
        "activity": "Activité",
        "model": "Modèle",
        "firmware": "Micrologiciel",
        "configuration": "Configuration",
        "statistics": "Statistiques"
    },
    "Table": {
        "1_wire_authorization": "Autorisation 1-Wire",
        "access group": "",
        "access groups": "",
        "access level": "Niveau d'accès",
        "accessories": "Accessoires",
        "action": "Action",
        "action date": "Date d'action",
        "assigned package": "Forfait attribué",
        "attempt count": "Nombre de tentatives",
        "attribute": "Attribut",
        "attributes": "Attributs",
        "auto sync": "",
        "batch id": "ID de lot",
        "ble_dtb": "BLE DTB",
        "ble_fw": "Micrologiciel BLE",
        "bluetooth_authorization": "Autorisation Bluetooth",
        "bootloader": "Bootloader",
        "can_adapter": "Adaptateur CAN",
        "can adapter name": "Nom de l'adaptateur CAN",
        "can bootstring": "Bootstring",
        "can oem file package": "Pack de fichiers OEM",
        "can oem file vehicle": "Véhicule de fichiers OEM",
        "can package": "Package CAN",
        "can program number": "Numéro de programme CAN",
        "can software date": "Date du logiciel CAN",
        "can type": "Type CAN",
        "carrier module id": "ID du module",
        "carrier revision": "Révision",
        "carrier serial id": "Identifiant série",
        "carrier settings filename": "Nom du fichier de paramètres",
        "carrier unit status": "Statut",
        "carrier unit type": "Type d'unité",
        "changed at": "Modifié le",
        "change origin": "",
        "changes": "Modifications",
        "checkbox disabled": {
            "role": "Les rôles statiques ne peuvent être ni modifiés ni supprimés."
        },
        "child company": "<0>Filiale de</0><1>{{parentCompany}}</1>",
        "child companies": "Filiales",
        "code": "Code",
        "company": "Entreprise",
        "company hierarchy": "Hiérarchie de l'entreprise",
        "company name": "Nom de l'entreprise",
        "compatibility": "Compatibilité",
        "configuration": "Configuration",
        "configuration details": "Détails de configuration",
        "configuration type": "",
        "created at": "Créé à",
        "created by": "Créé par",
        "date": "Date",
        "description": "Description",
        "device details": "Détails de l'appareil",
        "device company": "Entreprise d'appareils",
        "device description": "Description de l'appareil",
        "device group": "Groupe d'appareils",
        "device imei": "IMEI de l'appareil",
        "device model": "Modèle d'appareil",
        "device seen at": "Appareil vu à",
        "device serial": "Numéro de série de l'appareil.",
        "devices": "Appareils",
        "devices count": "Nombre d'appareils",
        "Done": "Terminé",
        "download at": "",
        "download file": "Télécharger le fichier",
        "dtb": "DTB",
        "edit file": "Modifier le fichier",
        "edit group banner": "Si un appareil est ajouté au groupe qui a défini un micrologiciel et/ou une configuration, toutes les tâches en attente du même type seront annulées.",
        "email": "E-mail",
        "empty table": {
            "no initial results": {
                "description": {
                    "batches": "Dès que les groupes de tâches sont créés, vous pouvez voir la liste ici",
                    "changes": "Dès que des modifications sont apportées, vous pourrez voir la liste ici",
                    "companies": "Dès que les entreprises seront créées, vous pourrez voir la liste ici",
                    "configurationChanges": "",
                    "desktopLicenses": "Dès que les licences Desktop auront été créées, vous pourrez voir la liste ici",
                    "devices": "Dès que les appareils sont téléchargés sur FOTA WEB, vous pouvez voir la liste ici",
                    "files": "Dès que les fichiers sont téléchargés, vous pouvez voir la liste ici",
                    "groups": "Dès que les groupes seront créés, vous pourrez voir la liste ici",
                    "offlineLicenses": "Dès que les licences hors ligne sont créées, vous pouvez voir la liste ici",
                    "permissions": "Dès que les autorisations sont attribuées à l'utilisateur, vous pourrez voir la liste ici",
                    "productCodes": "Dès que les codes produit seront créés, vous pourrez consulter la liste ici",
                    "roles": "Dès que les rôles sont créés, vous pouvez voir la liste ici",
                    "tasks": "Dès que les tâches sont créées, vous pouvez voir la liste ici",
                    "users": "Dès que des utilisateurs sont ajoutés, vous pouvez voir la liste ici"
                },
                "title": {
                    "batches": "Le tableau des groupes de tâches est vide",
                    "changes": "Le tableau des modifications est vide",
                    "companies": "Le tableau des entreprises est vide",
                    "configurationChanges": "",
                    "desktopLicenses": "Le tableau des licences Desktop est vide",
                    "devices": "Le tableau des appareils est vide",
                    "files": "Le tableau des fichiers est vide",
                    "groups": "Le tableau des groupes est vide",
                    "offlineLicenses": "Le tableau des licences hors ligne est vide",
                    "permissions": "Le tableau des autorisations est vide",
                    "productCodes": "Le tableau des codes produit est vide",
                    "roles": "Le tableau des rôles est vide",
                    "tasks": "Le tableau des tâches est vide",
                    "users": "Le tableau des utilisateurs est vide"
                }
            },
            "no permission": {
                "description": "Veuillez contacter votre administrateur pour demander l'accès.",
                "title": "Vous ne disposez pas des autorisations nécessaires pour afficher ce contenu"
            },
            "no results found": {
                "description": "Essayez un autre mot-clé ou filtre pour obtenir des résultats",
                "title": "Aucun résultat trouvé"
            },
            "button": {
                "add": {
                    "companies": "Créer une entreprise",
                    "devices": "Ajouter un appareil",
                    "files": "Télécharger un fichier",
                    "groups": "Créer un groupe",
                    "productCodes": "Ajouter un code produit",
                    "tasks": "Créer une tâche",
                    "users": "Inviter un utilisateur"
                },
                "reset view": "Réinitialiser l'affichage"
            }
        },
        "exausted autoscan limit": "Limite d'analyse automatique épuisée jusqu'à",
        "exausted vin parsing limit": "Limite d'analyse des numéros d'identification des véhicules (VIN) épuisée jusqu'à",
        "expiration": "Expiration",
        "expiration date": "Date d'expiration",
        "expires at": "Expire à",
        "expiry date": "Date d'expiration",
        "field": "Terrain",
        "file": "Fichier",
        "file id": "Identifiant de fichier",
        "files": "Fichiers",
        "file type": "Type de fichier",
        "filter by": "Filtrer par",
        "firmware": "Micrologiciel",
        "general": "Généralités",
        "general data": "Données générales",
        "gnss version": "Version GNSS",
        "group": "Groupe",
        "groups": "Groupes d'appareils",
        "group vip status": "",
        "gsm number": "Numéro GSM",
        "head title info": {
            "auto synced": {
                "changed at": "",
                "download at": "",
                "synced at": ""
            },
            "platform": {
                "fmx platform": "Plateforme FMx - modèles FMx (FMB, FMU, FMC, FMM), FMT, FMP, TAT, MSP, TFT, TST, GH (GH5200) et TMT.",
                "ft platform": "<1>Plateforme FT</1> - modèles FTx et ATx.",
                "legacy platform": "<1>Plateforme héritée</1> - Modèles FM (à l'exception des FM4001 et FM3010), FMA et GH (GH4000).",
                "title": "Génération de la plateforme du dispositif télématique"
            },
            "visibility": "Les modifications marquées comme <1>Internes</1> ne sont pas visibles par les clients. Étant donné que les modifications apportées aux appareils peuvent inclure à la fois des données visibles et cachées, <1>ne partagez pas de captures d'écran ou de détails dans vos communications externes</1>"
        },
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "imsi": "IMSI",
        "info": "Info",
        "interface": "Interface",
        "invited by": "Invité par",
        "items": "éléments",
        "last checked at": "Dernière vérification à",
        "last sign in": "Dernière connexion",
        "last status update": "Dernière mise à jour du statut",
        "last used at": "Dernière utilisation à",
        "license disabled": "Désactivé",
        "license enabled": "Activé",
        "license key": "Clé de licence",
        "license name": "",
        "links": "Liens",
        "manual_geofence_scenarios": "Scénarios de géorepérage manuel",
        "message": "Message",
        "model": "Modèle",
        "model task type support": {
            "false": "Non pris en charge",
            "true": "Prise en charge"
        },
        "modem version": "Version modem",
        "name": "Nom",
        "new value": "Nouvelle valeur ajoutée",
        "next task": "Tâche suivante",
        "no changes": "Aucune modification.",
        "no company name": "Pas de nom d'entreprise",
        "no details": "Aucun détail",
        "no file": "Aucun fichier",
        "no imei available": "Pas d'IMEI disponible",
        "no model": "Pas de modèle",
        "no parent company": "La société n'a pas de société mère.",
        "no tasks": "L'appareil n'a aucune tâche à accomplir.",
        "number": "Nombre",
        "obd": "OBD",
        "obd chip firmware version": "Version du micrologiciel de la puce OBD",
        "of": "de",
        "offline licenses tab disabled": "Les licences hors ligne ne sont pas disponibles pour les licences desktop désactivées.",
        "original value": "Valeur originale",
        "other information": "Autres informations",
        "page of": "page de",
        "parent company": "Société mère",
        "permission count": "Nombre d'autorisations",
        "platform": "Plateforme",
        "Price": "Prix",
        "product code": "Code produit",
        "program number": "Numéro du programme",
        "property": "Propriété",
        "queue": "File d'attente",
        "receiving company": "Entreprise destinataire",
        "revision": "Révision",
        "role": "Rôle",
        "role name": "Nom du rôle",
        "rows per page": "Lignes par page",
        "running": "En cours d'exécution",
        "schedule": "Planifier",
        "seen at": "Vu sur",
        "select row": "Sélectionnez une ligne pour afficher les détails",
        "send sms": "Envoi de SMS",
        "serial": "Numéro de série.",
        "show details": {
            "desktopLicenses": "Afficher les détails de la licence pour desktop",
            "devices": "Afficher les détails de l'appareil",
            "batches": "Afficher les détails du groupe de tâches",
            "tasks": "Afficher les détails de la tâche",
            "companies": "Afficher les détails de l'entreprise"
        },
        "sim": "SIM",
        "size": "Taille",
        "software date": "Date du logiciel",
        "source company": "Entreprise source",
        "spec_id": "Spec ID",
        "status": "Statut",
        "status id": "ID d'état",
        "status name": "Nom du statut",
        "supported task types": "Types de tâches pris en charge",
        "synced at": "",
        "table columns": "Colonnes du tableau",
        "target company": "Entreprise cible",
        "task id": "ID de tâche",
        "task queue": "File d'attente des tâches",
        "tasks": "Tâches",
        "task type": "Type de tâche",
        "tct web support": "Assistance TCT web",
        "total": "Total",
        "type": "Type",
        "updated at": "Mis à jour le",
        "updated by": "Mis à jour par",
        "unknown": "Inconnu",
        "user cannot be deleted": "L'utilisateur ne peut pas être supprimé.",
        "user cannot be edited": "L'utilisateur ne peut pas être modifié.",
        "user cannot delete himself": "Un utilisateur ne peut pas supprimer son propre profil.",
        "user date statuses": {
            "expired": "Expiré",
            "expires": "Expire",
            "never expires": "Sans date d'expiration",
            "sent": "Envoyé"
        },
        "user email": "E-mail de l'utilisateur",
        "user invitation cannot be cancelled": "L'invitation d'un utilisateur ne peut pas être annulée.",
        "user invitation cannot be resent": "Les invitations utilisateur ne peuvent pas être renvoyées.",
        "user statuses": {
            "Active": "Actif",
            "Inactive": "Inactif",
            "InvitationExpired": "Invitation expirée",
            "InvitationPending": "Invitation en attente"
        },
        "users": "Utilisateurs",
        "value from": "Valeur ajoutée",
        "value to": "Valeur ajoutée",
        "view all roles": "Tout afficher ({{count}})",
        "vin": "VIN",
        "vip status": "Statut VIP",
        "visibility": "Visibilité"
    },
    "Table details": {
        "bluetooth password": {
            "aria label unknown tooltip": "",
            "disabled copy tooltip": "",
            "unknown": "",
            "unknown tooltip": ""
        },
        "device group tasks": "",
        "group tasks": "",
        "number of devices": "",
        "permissions info": "Informations sur les autorisations",
        "smart group files": "",
        "tooltip info": {
            "devices": {
                "accessories": {
                    "interface": "Nom de l'interface accessoire.",
                    "type": "Type d'accessoire connecté."
                },
                "can": {
                    "assigned package": "le package OEM attribué à l'appareil.",
                    "can oem file package": "le package OEM signalé lors de la dernière connexion.",
                    "can oem file vehicle": "Configuration OEM du véhicule signalée lors de la dernière connexion.",
                    "dtb": "",
                    "firmware": "la version du micrologiciel CAN."
                },
                "can_adapter": {
                    "can adapter name": "",
                    "can bootstring": "la dernière chaîne de démarrage de l'adaptateur CAN reçue contenant les données actuelles et le numéro de programme de l'adaptateur.",
                    "program number": "Numéro de programme de l'adaptateur CAN.",
                    "revision": "",
                    "software date": "Date du logiciel de l'adaptateur CAN.",
                    "type": "le type d'adaptateur CAN."
                },
                "configuration details": {
                    "1_wire_authorization": "Dernier nom de fichier de liste d'autorisation 1-Wire envoyé.",
                    "bluetooth_authorization": "Nom du dernier fichier de liste d'autorisation Bluetooth envoyé.",
                    "main configuration": "Nom du dernier fichier de configuration principal envoyé.",
                    "manual_geofence_scenarios": "Dernier fichier de liste de géorepérage manuel envoyé."
                },
                "general": {
                    "ble_dtb": "",
                    "ble_fw": "Version du micrologiciel BLE signalée lors de la dernière connexion.",
                    "bluetooth password": "",
                    "bootloader": "Version du bootloader de l'appareil signalée lors de la dernière connexion.",
                    "company": "la société propriétaire de cet appareil.",
                    "configuration": "Nom du dernier fichier de configuration envoyé par le configurator.",
                    "description": "Description de l'appareil (définie par l'utilisateur).",
                    "dtb": "Version du blob de l'arborescence des appareils signalée lors de la dernière connexion.",
                    "firmware": "la version du micrologiciel de l'appareil signalée lors de la dernière connexion.",
                    "gnss version": "la version du GNSS signalée lors de la dernière connexion.",
                    "group": "le groupe d'appareils auquel cet appareil est affecté.",
                    "product code": "le code produit de l'appareil.",
                    "serial": "le numéro de série de l'appareil."
                },
                "obd": {
                    "obd chip firmware version": "Version du micrologiciel de la puce OBD signalée lors de la dernière connexion.",
                    "vin": "Code unique à 17 caractères qui identifie un véhicule à moteur spécifique."
                },
                "sim": {
                    "gsm number": "Numéro de téléphone public associé à un appareil.",
                    "iccid": "Numéro de série unique identifiant une carte SIM.",
                    "imsi": "Identifiant unique attribué à un abonné à un réseau mobile."
                }
            },
            "groups": {
                "fmx platform files": {
                    "configuration": "",
                    "firmware": ""
                },
                "ft platform files": {
                    "1_wire_authorization_list": "",
                    "bluetooth_authorization_list": "",
                    "firmware": "",
                    "main configuration": ""
                }
            },
            "users": {
                "general": {
                    "created at": "la date et l'heure de création de l'utilisateur.",
                    "id": "Identifiant unique de l'utilisateur.",
                    "invited by": "Adresse e-mail de l'utilisateur qui a créé l'invitation.",
                    "role": "Rôle(s) attribué(s) à l'utilisateur.",
                    "updated at": "la date et l'heure de la dernière mise à jour par l'utilisateur."
                }
            }
        },
        "user details": "Détails de l'utilisateur"
    },
    "Task groups": {
        "all": "Tout",
        "bulk type": {
            "CompanyBulkDelete": "Supprimer l'entreprise",
            "DeviceBulkCreate": "Ajouter un appareil",
            "DeviceBulkDelete": "Supprimer un appareil",
            "DeviceBulkUpdate": "Mettre à jour l'appareil",
            "FileBulkDelete": "Supprimer un fichier",
            "GroupBulkDelete": "Supprimer le groupe",
            "TaskBulkCreate": "Créer une tâche",
            "TaskBulkUpdate": "Annuler la tâche",
            "UserBulkDelete": "Supprimer un utilisateur"
        },
        "pending approval": "En attente d'approbation",
        "already approved": "Déjà approuvé",
        "no approval required": "Aucune autorisation requise",
        "total objects": "Nombre total d'objets",
        "total tasks": "Tâches totales"
    },
    "Task status": {
        "0": "En attente",
        "1": "En cours d'exécution",
        "2": "Terminé",
        "3": "Terminé avec des erreurs",
        "4": "Annulé",
        "5": "Échec",
        "6": "Expiré",
        "7": "En attente d'approbation",
        "8": "Vérification",
        "task count": {
            "0": "Tâches en attente",
            "1": "Exécution des tâches",
            "3": "Tâches terminées avec des erreurs",
            "5": "Tâches échouées"
        },
        "verified tooltip title": "La tâche a été accomplie avec succès et vérifiée par l'appareil."
    },
    "Tasks": {
        "0": "La tâche est dans la file d'attente et est désormais en attente.",
        "1": "La tâche est actuellement en cours d'exécution.",
        "2": "La tâche a été accomplie avec succès.",
        "3": "La tâche a été accomplie, mais certaines erreurs se sont produites.",
        "4": "La tâche a été annulée.",
        "5": "La tâche a échoué.",
        "6": "La tâche n'a pas été accomplie dans un certain délai."
    },
    "Tct": {
        "edit configuration": "Modifier la configuration",
        "no editable configurations": "Aucune configuration modifiable n'est téléchargée",
        "open tct": "Ouvrir la version TCT web",
        "open tct description": "Choisissez de créer une nouvelle configuration dans la version TCT web ou modifiez un fichier de configuration existant à partir de FOTA WEB.",
        "select configuration file": "Sélectionnez le fichier de configuration que vous souhaitez modifier dans TCT web.",
        "tct web": "TCT web",
        "tct web disabled description": "La version TCT web est uniquement disponible pour les entreprises de niveau Premium."
    },
    "Tutorial": {
        "buttons": {
            "exit": "",
            "finish": "",
            "get started": "",
            "next": "",
            "next feature": ""
        },
        "content": {
            "company selector": {
                "0": "",
                "1": "",
                "1-info": ""
            },
            "finish tutorial": "",
            "first time user": "",
            "task groups": {
                "desktop": {
                    "0": "",
                    "1": ""
                },
                "mobile": {
                    "0": "",
                    "1": ""
                }
            }
        },
        "titles": {
            "finish tutorial": "",
            "first time user": "",
            "tutorial mode": ""
        }
    }
}
